<template>
  <div>
    <v-stepper-items>
      <v-stepper-content
          v-for="(n, index) in stepperSteps"
          :key="`${Number(n.number)}-content`"
          :step="Number(n.number)">

        <div class="row">
          <div class="col-md-6">
            <div class="productImageContainer" @click="dialogLargeimage = true">
              <div class="productImageContainer-inner">
                <img :src="imgURLcomputed" v-if="imgURLcomputed" @error="imgURLcomputed=imgFallback+imgURLcomputedFilename" class="productImage productImageComputed" />
                <img :src="imgURLstart" v-else class="productImage productImageStart" />
              </div>
            </div>
          </div>
          <div class="col-md-6 text-left">
            <div class="col-wrapper">
              <v-container v-if="LoadingCustomProducts && n.number > 1">
                <div class="text-xs-center d-flex justify-center align-center">
                  <v-progress-circular
                      indeterminate
                      :size="50"
                      :width="3"
                      color="primary">
                  </v-progress-circular>
                </div>
              </v-container>
              <v-container
                  v-else
                  :class="`stepContainer${n.number}`"
              >
                <h2 class="primary--text">{{ stepPrefix }} {{ Number(n.number) }}. {{ n.name}}</h2>
                <p class="mt-3">{{ n.intro }}</p>

                <!-- Create accordion from the options in the current step -->
                <v-expansion-panels accordion class="mt-6" v-model="panel" v-if="index != stepperSteps.length - 1">
                  <v-expansion-panel
                      v-for="(a, index) in n.accordion"
                      :key="`${a.name}-itemmm`"
                      v-bind:class="{ 'accordion-grayedout' : !n.accordion[indexCalc(index)].value && index !== 0 }"
                  >


                    <!-- just for price input (needs to be outside of the collapse accordion -->
                    <template>
                      <v-expansion-panel-header>
                        <template v-slot:default="{ open }">
                          <v-row no-gutters align="center">
                            <span class="mr-2">
                                <v-icon color="primary" v-if="a.value">
                                    {{ svgPath.CheckCircleOn }}
                                </v-icon>
                                <v-icon color="grey lighten-2" v-else>
                                    {{ svgPath.CheckCircleOn }}
                                </v-icon>
                                {{ a.name }}
                            </span>
                            <span
                                class="text--secondary">
                              <v-fade-transition leave-absolute>
                                  <span
                                      v-if="open"
                                      key="0">
                                    {{ a.actionText }}
                                  </span>
                                  <span
                                      v-else
                                      key="1">
                                      {{ a.value }}
                                  </span>
                              </v-fade-transition>
                          </span>
                          </v-row>
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div v-if="a.intro" v-html="a.intro"></div>
                        <img :src="DrawerRunnerImgUrl" class="drawerrunner-img" v-if="a.name === findElement.typeDrawerRunner.Accordion && DrawerRunnerImgUrl" />

                        <div class="duo-stepper-panel-input">

                          <div
                              v-for="item in a.items"
                              :key="`${item.title}-item`"
                          >

                            <!-- API radio button Brand Categories -->
                            <div
                                row
                                v-if="item.type === 'radio-cat'"
                            >
                              <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                              <div v-if="item.intro" v-html="item.intro"></div>
                              <v-row>
                                <v-col
                                    v-for="b in item.options"
                                    v-bind:key="b.value"
                                    sm="6"
                                    md="6"
                                    lg="4"
                                >
                                  <v-hover v-slot="{ hover }">
                                    <label
                                        class="radio-label text-center"
                                        :class="{ 'radio-label-hover': hover }"
                                        @click="setSelectedCat(b.catid)"
                                        v-on:click="clearOptions(); item.selectedPrice = b.price + item.price; step1Brand = b.valCode; item.valCode = b.valCode; item.selectedLabel = b.label; item.catid = b.catid; stepperSteps[0].accordion[1].value = ''; stepperSteps[0].accordion[1].items[0].value = ''; stepperSteps[0].accordion[1].items[0].selectedLabel = ''; stepperSteps[0].accordion[2].value = ''; stepperSteps[0].accordion[2].items[0].value = ''; stepperSteps[0].accordion[2].items[0].selectedLabel = '';"
                                    >
                                      <input type="radio" v-model="item.value" :value="b.label" :name="b.parentId" />
                                      <v-badge
                                          :content="`Vanaf ${formatPrice(b.price)}`"
                                          color="gray"
                                          bordered
                                          overlap
                                          v-if="b.price"></v-badge>
                                      <div class="label-inner">
                                        <v-tooltip
                                            top v-if="b.tooltip"
                                            max-width="300"
                                        >
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-icon icon
                                                    small
                                                    color="grey lighten-1"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="icon-tooltip">
                                              {{ svgPath.help }}
                                            </v-icon>
                                          </template>
                                          <span>{{b.tooltip}}</span>
                                        </v-tooltip>
                                        <div class="label-inner-img-label">
                                          <div class="label-inner-img">
                                            <img :src="`${b.img}`" />
                                          </div>
                                          <span v-html="b.label"></span>
                                        </div>
                                      </div>
                                    </label>
                                  </v-hover>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- API radio button Sub Categories -->
                            <div
                                row
                                v-if="item.type === 'radio-subcat'"
                            >
                              <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                              <div v-if="item.intro" v-html="item.intro"></div>
                              <div v-if="selectedBrand === ''">
                                Maak eerst een keuze bij {{stepperSteps[0].accordion[0].name}}
                              </div>
                              <v-row v-else>
                                <v-hover
                                    v-slot="{ hover }"
                                    v-for="b in item.options"
                                    v-bind:key="b.value"
                                >
                                  <v-col
                                      v-if="b.parentId === selectedBrand"
                                      sm="6"
                                      md="6"
                                      lg="4">
                                    <label
                                        class="radio-label text-center"
                                        :class="{ 'radio-label-hover': hover }"
                                        v-on:click="clearOptions(); item.selectedPrice = b.price + item.price; step1Type = b.valCode; step1TypeProductID = b.catid; item.valCode = b.valCode; item.selectedLabel = b.label; selectedType = b.catid; item.catid = b.catid; stepperSteps[0].accordion[2].value = ''; stepperSteps[0].accordion[2].items[0].value = ''; stepperSteps[0].accordion[2].items[0].selectedLabel = '';"
                                    >
                                      <input type="radio" v-model="item.value" :value="`${b.label}${b.parentId}`" :name="b.parentId" />
                                      <v-badge
                                          :content="`Vanaf ${formatPrice(b.price)}`"
                                          color="gray"
                                          bordered
                                          overlap
                                          v-if="b.price"></v-badge>
                                      <div class="label-inner">
                                        <v-tooltip
                                            top v-if="b.tooltip"
                                            max-width="300"
                                        >
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-icon icon
                                                    small
                                                    color="grey lighten-1"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="icon-tooltip">
                                              {{ svgPath.help }}
                                            </v-icon>
                                          </template>
                                          <span>{{b.tooltip}}</span>
                                        </v-tooltip>
                                        <div class="label-inner-img-label">
                                          <div class="label-inner-img">
                                            <img :src="`${b.img}`" />
                                          </div>
                                          <span v-html="b.label"></span>
                                        </div>
                                      </div>
                                    </label>
                                  </v-col>
                                </v-hover>
                              </v-row>
                            </div>

                            <!-- Hoogte Step1 Select -->
                            <div v-else-if="item.type === 'radio-subcat-hoogte'"
                                 v-bind:class="{ 'height-loading' : heightLoader }">
                              <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                              <div v-if="item.intro" v-html="item.intro"></div>
                              <v-select
                                  v-model="item.value"
                                  :items="selectedTypeHeights"
                                  item-value="value"
                                  item-text="label"
                                  :label="ifEmptyLabel(item.inputPlaceholder)"
                                  :return-object="true"
                                  outlined
                                  @input="item.selectedPrice = $event.price + item.price; item.value = $event.value; step1Height = $event.valCode; step1HeightproductID = $event.productId; item.valCode = $event.valCode; item.selectedLabel = $event.label + ' mm'; heightLoader = true; getOptionsCustomProducts($event)"
                              >
                                <template slot="selection" slot-scope="data">
                                  <!-- HTML that describe how select should render selected items -->
                                  {{ data.item.label }} mm - <v-badge :content="`+ ` + formatPrice(data.item.price)" color="primary" overlap bottom class="vbadge-relative"></v-badge>
                                    <v-progress-circular
                                        indeterminate
                                        :size="15"
                                        :width="2"
                                        color="primary"
                                        style="margin-left:5px;"
                                        v-if="heightLoader"
                                    >
                                    </v-progress-circular>
                                </template>
                                <template slot="item" slot-scope="data">
                                  <!-- HTML that describe how select should render items when the select is open -->
                                  {{ data.item.label }} mm - <v-badge :content="`+ ` + formatPrice(data.item.price)" color="primary" overlap bottom class="vbadge-relative"></v-badge>
                                </template>
                              </v-select>
                            </div>

                            <!-- Imageselect (color) button -->
                            <div
                                v-if="(item.type === 'imageselect' || item.type === 'colorselect') && item.title !== findElement.FilllistColor.Item"
                                row
                            >
                              <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                              <div v-if="item.intro" v-html="item.intro"></div>
                              <v-row>
                                <v-col
                                    v-for="opt in item.options"
                                    v-bind:key="opt.value"
                                    sm="6"
                                    md="6"
                                    lg="4"
                                    :class="{ 'select-no' : item.title === findElement.Antislipmat.Item }"
                                >
                                  <v-hover v-slot="{ hover }">
                                    <label
                                        class="radio-label text-center test-label"
                                        :class="{ 'radio-label-hover': hover }"
                                        v-on:click="item.selectedPrice = opt.price + item.price; item.valCode = opt.valCode; item.selectedLabel = opt.label;"
                                    >
                                      <input type="radio" v-model="item.value" :value="opt.value" :name="item.name" />
                                      <v-badge
                                          :content="`+ ` + formatPrice(opt.price)"
                                          color="gray"
                                          bordered
                                          overlap
                                          v-if="opt.price"
                                      ></v-badge>
                                      <div class="label-inner">
                                        <v-tooltip
                                            top v-if="opt.tooltip"
                                            max-width="300"
                                        >
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-icon icon
                                                    small
                                                    color="grey lighten-1"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="icon-tooltip">
                                              {{ svgPath.help }}
                                            </v-icon>
                                          </template>
                                          <span>{{opt.tooltip}}</span>
                                        </v-tooltip>
                                        <div v-if="ifIsColor(opt.img)" style="display:inline-block;width:100%;padding-top:100%;" :style="{backgroundColor: opt.img}"></div>
                                        <img v-else :src="opt.img" />
                                        <span v-html="opt.label"></span>
                                      </div>
                                    </label>
                                  </v-hover>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Imageselect (color) button Kleur opvulling -->
                            <div
                                v-if="(item.type === 'imageselect' || item.type === 'colorselect') && item.title === findElement.FilllistColor.Item && OptionsSelected.showFilllistColor"
                                row
                            >
                              <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                              <div v-if="item.intro" v-html="item.intro"></div>
                              <v-row>
                                <v-col
                                    v-for="opt in item.options"
                                    v-bind:key="opt.value"
                                    sm="6"
                                    md="6"
                                    lg="4"
                                    :class="{ 'select-no' : item.title === findElement.Antislipmat.Item }"
                                >
                                  <v-hover v-slot="{ hover }">
                                    <label
                                        class="radio-label text-center test-label"
                                        :class="{ 'radio-label-hover': hover }"
                                        v-on:click="item.selectedPrice = opt.price + item.price; item.valCode = opt.valCode; item.selectedLabel = opt.label;"
                                    >
                                      <input type="radio" v-model="item.value" :value="opt.value" :name="item.name" />
                                      <v-badge
                                          :content="`+ ` + formatPrice(opt.price)"
                                          color="gray"
                                          bordered
                                          overlap
                                          v-if="opt.price"
                                      ></v-badge>
                                      <div class="label-inner">
                                        <v-tooltip
                                            top v-if="opt.tooltip"
                                            max-width="300"
                                        >
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-icon icon
                                                    small
                                                    color="grey lighten-1"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="icon-tooltip">
                                              {{ svgPath.help }}
                                            </v-icon>
                                          </template>
                                          <span>{{opt.tooltip}}</span>
                                        </v-tooltip>
                                        <div v-if="ifIsColor(opt.img)" style="display:inline-block;width:100%;padding-top:100%;" :style="{backgroundColor: opt.img}"></div>
                                        <img v-else :src="opt.img" />
                                        <span v-html="opt.label"></span>
                                      </div>
                                    </label>
                                  </v-hover>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Radio button & staffelprijzen uitgesloten -->
                            <div
                                v-if="item.type === 'radio' && item.title !== findElement.LoadCapacity.Item && item.title !== findElement.sidewallGlassSelected.Item && item.title !== findElement.drawerDriver.Item && item.title !== findElement.widthGraduatedPrice.Item && item.title !== findElement.widthAntislipmatGraduatedPrice.Item && item.title !== findElement.depthSidewallGlass.Item && item.title !== findElement.widthDrawerFrontLowGraduatedPrice.Item && item.title !== findElement.widthDrawerFrontHighGraduatedPrice.Item"
                                class="NormalRadioButton">
                              <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                              <div v-if="item.intro" v-html="item.intro"></div>
                              <v-radio-group v-model="item.value" row>

                                <v-hover
                                    v-slot="{ hover }"
                                    v-for="opt in item.options"
                                    v-bind:key="opt.value">
                                  <v-radio
                                      :value="opt.value"
                                      v-on:click="item.selectedPrice = opt.price + item.price; item.valCode = opt.valCode; item.selectedLabel = opt.label;"
                                  >
                                    <template v-slot:label>
                                      <div class="radio-label"
                                           :class="{ 'radio-label-hover': hover, 'label-with-price' : opt.price}"
                                      >
                                        <span>
                                          {{opt.label}}
                                        </span>
                                        <div class="badgeAndTooltip">
                                          <v-badge
                                              :content="`+ ` + formatPrice(opt.price)"
                                              color="gray"
                                              bordered
                                              overlap
                                              v-if="opt.price"
                                          ></v-badge>
                                          <v-tooltip
                                              top v-if="opt.tooltip"
                                              max-width="300"
                                          >
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-icon icon
                                                      small
                                                      color="grey lighten-1"
                                                      v-bind="attrs"
                                                      v-on="on"
                                                      class="icon-tooltip">
                                                {{ svgPath.help }}
                                              </v-icon>
                                            </template>
                                            <span>{{opt.tooltip}}</span>
                                          </v-tooltip>
                                        </div>
                                      </div>
                                    </template>
                                  </v-radio>
                                </v-hover>

                              </v-radio-group>

                            </div>

                            <!-- Radio button LoadCapacity -->
                            <div
                                v-if="item.type === 'radio' && item.title === findElement.LoadCapacity.Item"
                                v-bind:class="{ 'item-grayedout' : OptionsSelected.showLoadCapacity === false, 'item-grayedout-forceyes' : OptionsSelected.forceLoadCapacity === true}"
                            >
                              <div>
                                <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                                <div v-if="item.intro" v-html="item.intro"></div>
                                <v-radio-group v-model="item.value" row>

                                  <v-hover
                                      v-slot="{ hover }"
                                      v-for="opt in item.options"
                                      v-bind:key="opt.value">
                                    <v-radio
                                        :value="opt.value"
                                        v-on:click="item.selectedPrice = opt.price + item.price; item.valCode = opt.valCode; item.selectedLabel = opt.label;"
                                    >
                                      <template v-slot:label>
                                        <div class="radio-label"
                                             :class="{ 'radio-label-hover': hover, 'label-with-price' : opt.price}"
                                        >
                                          <span>
                                            {{opt.label}}
                                          </span>
                                          <div class="badgeAndTooltip">
                                            <v-badge
                                                :content="`+ ` + formatPrice(opt.price)"
                                                color="gray"
                                                bordered
                                                overlap
                                                v-if="opt.price"
                                            ></v-badge>
                                            <v-tooltip
                                                top v-if="opt.tooltip"
                                                max-width="300"
                                            >
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-icon icon
                                                        small
                                                        color="grey lighten-1"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="icon-tooltip">
                                                  {{ svgPath.help }}
                                                </v-icon>
                                              </template>
                                              <span>{{opt.tooltip}}</span>
                                            </v-tooltip>
                                          </div>
                                        </div>
                                      </template>
                                    </v-radio>
                                  </v-hover>

                                </v-radio-group>
                              </div>
                            </div>

                            <!-- Radio button showSidewallGlass -->
                            <div
                                v-if="item.type === 'radio' && item.title === findElement.sidewallGlassSelected.Item"
                                v-bind:class="{ 'item-grayedout' : OptionsSelected.showSidewallGlass === false}"
                            >
                              <div>
                                <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                                <div v-if="item.intro" v-html="item.intro"></div>
                                <v-radio-group v-model="item.value" row>

                                  <v-hover
                                      v-slot="{ hover }"
                                      v-for="opt in item.options"
                                      v-bind:key="opt.value">
                                    <v-radio
                                        :value="opt.value"
                                        v-on:click="item.selectedPrice = opt.price + item.price; item.valCode = opt.valCode; item.selectedLabel = opt.label;"
                                    >
                                      <template v-slot:label>
                                        <div class="radio-label"
                                             :class="{ 'radio-label-hover': hover, 'label-with-price' : opt.price}"
                                        >
                                          <span>{{opt.label}}</span>
                                          <div class="badgeAndTooltip">
                                            <v-badge
                                                :content="`+ ` + formatPrice(opt.price)"
                                                color="gray"
                                                bordered
                                                overlap
                                                v-if="opt.price"
                                            ></v-badge>
                                            <v-tooltip
                                                top v-if="opt.tooltip"
                                                max-width="300"
                                            >
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-icon icon
                                                        small
                                                        color="grey lighten-1"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="icon-tooltip">
                                                  {{ svgPath.help }}
                                                </v-icon>
                                              </template>
                                              <span>{{opt.tooltip}}</span>
                                            </v-tooltip>
                                          </div>
                                        </div>
                                      </template>
                                    </v-radio>
                                  </v-hover>

                                </v-radio-group>
                              </div>
                            </div>

                            <!-- Radio button drawerDriver -->
                            <div
                                v-if="item.type === 'radio' && item.title === findElement.drawerDriver.Item"
                                class="DriverRadioButton"
                                :data-showdriver="OptionsSelected.showDriver" :data-drawerDriver="findElement.drawerDriver.Item"
                                v-bind:class="{ 'item-grayedout' : OptionsSelected.showDriver === false}"
                            >
                              <div>
                                <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                                <div v-if="item.intro" v-html="item.intro"></div>
                                <v-radio-group v-model="item.value" row>

                                  <v-hover
                                      v-slot="{ hover }"
                                      v-for="opt in item.options"
                                      v-bind:key="opt.value">
                                    <v-radio
                                        :value="opt.value"
                                        v-on:click="item.selectedPrice = opt.price + item.price; item.valCode = opt.valCode; item.selectedLabel = opt.label;"
                                    >
                                      <template v-slot:label>
                                        <div class="radio-label"
                                             :class="{ 'radio-label-hover': hover, 'label-with-price' : opt.price}"
                                        >
                                          <span>{{opt.label}}</span>
                                          <div class="badgeAndTooltip">
                                            <v-badge
                                                :content="`+ ` + formatPrice(opt.price)"
                                                color="gray"
                                                bordered
                                                overlap
                                                v-if="opt.price"
                                            ></v-badge>
                                            <v-tooltip
                                                top v-if="opt.tooltip"
                                                max-width="300"
                                            >
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-icon icon
                                                        small
                                                        color="grey lighten-1"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="icon-tooltip">
                                                  {{ svgPath.help }}
                                                </v-icon>
                                              </template>
                                              <span>{{opt.tooltip}}</span>
                                            </v-tooltip>
                                          </div>
                                        </div>
                                      </template>
                                    </v-radio>
                                  </v-hover>

                                </v-radio-group>
                              </div>
                            </div>

                            <!-- Checkbox button -->
                            <div
                                v-if="item.type === 'checkbox'"
                                row
                            >
                              <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                              <div v-if="item.intro" v-html="item.intro"></div>
                              <v-row>
                                <v-col
                                    v-for="opt in item.options"
                                    v-bind:key="opt.value"
                                    sm="6"
                                    md="6"
                                    lg="4">
                                  <v-hover v-slot="{ hover }">
                                    <v-checkbox
                                        v-model="item.value"
                                        :value="opt.value"
                                        v-on:click="item.selectedPrice = opt.price + item.price; item.valCode = opt.valCode; item.selectedLabel = opt.label;"
                                    >
                                      <template v-slot:label>
                                        <div
                                            class="checkbox-label text-center"
                                            :class="{ 'checkbox-label-hover': hover, 'label-with-price' : opt.price}">
                                          <v-badge
                                              :content="`+ ` + formatPrice(opt.price)"
                                              color="gray"
                                              bordered
                                              overlap
                                              v-if="opt.price"
                                          ></v-badge>
                                          <div class="label-inner">
                                            <v-tooltip
                                                top v-if="opt.tooltip"
                                                max-width="300"
                                            >
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-icon icon
                                                        small
                                                        color="grey lighten-1"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="icon-tooltip">
                                                  {{ svgPath.help }}
                                                </v-icon>
                                              </template>
                                              <span>{{opt.tooltip}}</span>
                                            </v-tooltip>
                                            <span v-html="opt.label"></span>
                                          </div>
                                        </div>
                                      </template>
                                    </v-checkbox>
                                  </v-hover>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Select -->
                            <div v-else-if="item.type === 'select'">
                              <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                              <div v-if="item.intro" v-html="item.intro"></div>
                              <v-select
                                  v-model="item.value"
                                  :items="item.options"
                                  :item-value="item=>item.value"
                                  :item-text="item=>item.label"
                                  :label="ifEmptyLabel(item.label)"
                                  v-on:change="item.selectedPrice = $event.price + item.price; item.value = $event.value; item.valCode = $event.valCode; item.selectedLabel = $event.label;"
                                  :return-object="true"
                                  outlined
                              >
                                <template slot="selection" slot-scope="data">
                                  <!-- HTML that describe how select should render selected items -->
                                  {{ data.item.label }} - <span v-if="data.item.valCode === '1S' || data.item.valCode === '2S'" class="sifonwidthSL"> {{OptionsSelected.minSifonWidthS}} mm - </span><span v-if="data.item.valCode === '1L' || data.item.valCode === '2L'" class="sifonwidthSL"> {{OptionsSelected.minSifonWidthL}} mm - </span><v-badge :content="`+ ` + formatPrice(data.item.price)" color="primary" overlap bottom class="vbadge-relative"></v-badge>
                                </template>
                                <template slot="item" slot-scope="data">
                                  <!-- HTML that describe how select should render items when the select is open -->
                                  {{ data.item.label }} - <span v-if="data.item.valCode === '1S' || data.item.valCode === '2S'" class="sifonwidthSL"> {{OptionsSelected.minSifonWidthS}} mm - </span><span v-if="data.item.valCode === '1L' || data.item.valCode === '2L'" class="sifonwidthSL"> {{OptionsSelected.minSifonWidthL}} mm - </span><v-badge :content="`+ ` + formatPrice(data.item.price)" color="primary" overlap bottom class="vbadge-relative"></v-badge>
                                  <div class="badgeAndTooltip" v-if="data.item.tooltip" style="margin-left:5px;">
                                    -
                                    <v-tooltip
                                        top
                                        max-width="300"
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon icon
                                                small
                                                color="grey lighten-1"
                                                v-bind="attrs"
                                                v-on="on"
                                                class="icon-tooltip">
                                          {{ svgPath.help }}
                                        </v-icon>
                                      </template>
                                      <span>{{data.item.tooltip}}</span>
                                    </v-tooltip>
                                  </div>
                                </template>
                              </v-select>
                            </div>

                            <!-- Tekstfield -->
                            <div v-else-if="item.type === 'textfield'">
                              <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                              <div v-if="item.intro" v-html="item.intro"></div>
                              <v-text-field
                                  v-model="item.value"
                                  :placeholder="ifEmptyPlaceholder(item.inputPlaceholder)"
                                  :label="ifEmptyLabel(item.label)"
                                  outlined>
                              </v-text-field>
                            </div>

                            <!-- Numberfield -->
                            <div v-else-if="item.type === 'numberfield'">
                              <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                              <div v-if="item.intro" v-html="item.intro"></div>
                              <v-text-field
                                  v-model="item.value"
                                  type="number"
                                  :placeholder="ifEmptyPlaceholder(item.inputPlaceholder)"
                                  :label="ifEmptyLabel(item.label)"
                                  outlined>
                              </v-text-field>
                            </div>

                            <!-- Slider -->
                            <div v-if="item.type === 'slider'" class="slider-item">
                              <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                              <div v-if="item.intro" v-html="item.intro"></div>
                              <v-container class="slider-container" v-bind:class="{ 'invisible' : !a.value }">
                                <div class="slider-staffellabel" v-html="item.StaffelLabel"></div>
                                <v-badge
                                    :content="`+ ` + formatPrice(item.selectedPrice)"
                                    color="primary"
                                    overlap
                                    bottom
                                    class="slider-vbadge"
                                ></v-badge>
                              </v-container>
                              <div>
                                <v-text-field
                                    type="number"
                                    v-model="item.value"
                                    class="mt-0 pt-0"
                                    style="width: 115px"
                                    @change="setMinMaxInput();"
                                    required
                                    dense
                                    solo
                                    :min="minWidthSlider"
                                    :max="item.rangeMax"
                                    suffix="mm"
                                >
                                </v-text-field>
                                <div class="slider-container-hint" v-html="`min ${minWidthSlider} mm / max ${item.rangeMax} mm`"></div>
                              </div>
<!--                              <v-slider-->
<!--                                  v-model="item.value"-->
<!--                                  track-color="grey lighten-5"-->
<!--                                  :hint="`min ${minWidthSlider} mm / max ${item.rangeMax} mm`"-->
<!--                                  persistent-hint-->
<!--                                  :min="minWidthSlider"-->
<!--                                  :max="item.rangeMax"-->
<!--                                  v-on:change="calcDrawing('middle', drawingValue3, 'slider'); changeWidthPrice(item.value); setFullWidth(item.value); item.selectedLabel = item.value + ' mm'; checkIsItemDisabled();">-->

<!--                                <template v-slot:append>-->
<!--                                  <v-text-field-->
<!--                                      type="number"-->
<!--                                      v-model="item.value"-->
<!--                                      class="mt-0 pt-0"-->
<!--                                      style="width: 115px"-->
<!--                                      @change="calcDrawing('middle', drawingValue3, 'sliderclick'); changeWidthPrice(item.value); setFullWidth(item.value); item.selectedLabel = item.value + ' mm'; checkIsItemDisabled();"-->
<!--                                      required-->
<!--                                      dense-->
<!--                                      solo-->
<!--                                      :min="minWidthSlider"-->
<!--                                      :max="item.rangeMax"-->
<!--                                      suffix="mm"-->
<!--                                  >-->
<!--                                  </v-text-field>-->
<!--                                </template>-->

<!--                              </v-slider>-->
                            </div>

                            <!-- Drawing Single Sifon -->
                            <v-container
                                v-if="item.type === 'drawing' && OptionsSelected.typeSifon == 'single'"
                                class="centered-number drawing-container drawing-container-single">
                              <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                              <div v-if="item.intro" v-html="item.intro"></div>
                              <v-row>
                                <v-col
                                    cols="12"
                                    md="12"
                                    class="pb-0"
                                >
                                  <div class="full-width-drawing">Totaal binnenwerkse kastbreedte: {{fullWidthDrawing}} mm</div>
                                  <div class="polygon-drawing">
                                    <svg version="1.1"
                                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                         x="0px"
                                         y="0px"
                                         viewBox="0 0 101.6 27.427"
                                         enable-background="new 0 0 101.6 27.427"
                                         xml:space="preserve">
                                          <polygon
                                              fill="#C8C7C7"
                                              stroke="#A0A0A0"
                                              stroke-width="1.575"
                                              stroke-miterlimit="10"
                                              :points="polygonPoints"/>
                                      </svg>
                                  </div>
                                  <div class="line-drawing">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 101.6 5.009" enable-background="new 0 0 101.6 5.009" xml:space="preserve">
                                      <line id="fixedValue1" fill="none" stroke="#F49819" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :x1="fixedValue1" y1="5.009" :x2="fixedValue1" y2="2.504"/>
                                      <line id="fixedValue2" fill="none" stroke="#e4e4e4" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :x1="fixedValue2" y1="5.009" :x2="fixedValue2" y2="2.504"/>
                                      <line id="fixedValue3" fill="none" stroke="#F49819" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :x1="fixedValue3" y1="5.009" :x2="fixedValue3" y2="2.504"/>
                                      <polyline id="val1" fill="none" stroke="#F49819" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :points="lineVal1"/>
                                      <line id="val2" fill="none" stroke="#e4e4e4" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :x1="lineVal2x1" y1="2.504" :x2="lineVal2x2" y2="2.504"/>
                                      <polyline id="val3" fill="none" stroke="#F49819" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :points="lineVal3"/>
                                      </svg>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row style="padding: 0 10px;">
                                <div class="val1A text-center pt-0" :style="`width: ${widthVal1}%`">A</div>
                                <div class="val2B text-center pt-0" :style="`width: ${widthVal2}%;color:#9a9a9a;`">B</div>
                                <div class="val3C text-center pt-0" :style="`width: ${widthVal3}%`">C</div>
                              </v-row>
                              <v-row>
                                <v-col
                                    cols="12"
                                    md="4"
                                >
                                  <v-text-field
                                      v-model="drawingValue1"
                                      type="number"
                                      @change="calcDrawing('left', drawingValue1)"
                                      prefix="A"
                                      :min="minWidthLeft"
                                      :max="maxWidthLeft"
                                      suffix="mm"
                                      required
                                      dense
                                      solo
                                  ></v-text-field>
                                </v-col>

                                <v-col
                                    cols="12"
                                    md="4"
                                >
                                  <v-text-field
                                      v-model="drawingValue2"
                                      type="number"
                                      prefix="B"
                                      suffix="mm"
                                      required
                                      dense
                                      solo-inverted
                                      disabled
                                  ></v-text-field>
                                </v-col>

                                <v-col
                                    cols="12"
                                    md="4"
                                >
                                  <v-text-field
                                      v-model="drawingValue3"
                                      type="number"
                                      prefix="C"
                                      suffix="mm"
                                      @change="calcDrawing('right', drawingValue3)"
                                      :min="minWidthRight"
                                      :max="maxWidthRight"
                                      required
                                      dense
                                      solo
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-alert type="info" v-if="minMaxAlert" dense>
                                {{ minMaxAlert }}
                              </v-alert>
                            </v-container>

                            <!-- Drawing Double Sifon -->
                            <v-container
                                v-if="item.type === 'drawing' && OptionsSelected.typeSifon == 'double'"
                                class="centered-number drawing-container drawing-container-double">
                              <h3 v-if="item.title" v-html="item.title" class="item--title"></h3>
                              <div v-if="item.intro" v-html="item.intro"></div>
                              <v-row>
                                <v-col
                                    cols="12"
                                    md="12"
                                    class="pb-0"
                                >
                                  <div class="full-width-drawing">Totaal binnenwerkse kastbreedte: {{fullWidthDrawing}}mm</div>
                                  <div class="polygon-drawing">
                                    <svg version="1.1"
                                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                         x="0px"
                                         y="0px"
                                         viewBox="0 0 101.6 27.427"
                                         enable-background="new 0 0 101.6 27.427"
                                         xml:space="preserve">
                                          <polygon
                                              fill="#C8C7C7"
                                              stroke="#A0A0A0"
                                              stroke-width="1.575"
                                              stroke-miterlimit="10"
                                              :points="polygonPointsDouble" />
                                      </svg>
                                  </div>
                                  <div class="line-drawing">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 101.6 5.009" enable-background="new 0 0 101.6 5.009" xml:space="preserve">
                                      <line id="fixedValueDouble1" fill="none" stroke="#F49819" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :x1="fixedValueDouble1" y1="5.009" :x2="fixedValueDouble1" y2="2.504"/>
                                      <line id="fixedValueDouble2" fill="none" stroke="#e4e4e4" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :x1="fixedValueDouble2" y1="5.009" :x2="fixedValueDouble2" y2="2.504"/>
                                      <line id="fixedValueDouble3" fill="none" stroke="#F49819" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :x1="fixedValueDouble3" y1="5.009" :x2="fixedValueDouble3" y2="2.504"/>
                                      <line id="fixedValueDouble4" fill="none" stroke="#e4e4e4" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :x1="fixedValueDouble4" y1="5.009" :x2="fixedValueDouble4" y2="2.504"/>
                                      <line id="fixedValueDouble5" fill="none" stroke="#F49819" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :x1="fixedValueDouble5" y1="5.009" :x2="fixedValueDouble5" y2="2.504"/>
                                      <polyline id="valDouble1" fill="none" stroke="#F49819" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :points="lineValDouble1"/>
                                      <line id="valDouble2" fill="none" stroke="#e4e4e4" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :x1="lineValDouble2x1" y1="2.504" :x2="lineValDouble2x2" y2="2.504"/>
                                      <polyline id="valDouble3" fill="none" stroke="#F49819" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :points="lineValDouble3"/>
                                      <line id="valDouble4" fill="none" stroke="#e4e4e4" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :x1="lineValDouble4x1" y1="2.504" :x2="lineValDouble4x2" y2="2.504"/>
                                      <polyline id="valDouble5" fill="none" stroke="#F49819" :stroke-width="dottedLineWidth" stroke-miterlimit="10" :stroke-dasharray="dottedLineWidth * 2" :points="lineValDouble5"/>
                                    </svg>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row style="padding: 0 10px;">
                                <div class="val1A text-center pt-0" :style="`width: ${widthValDouble1}%`">A</div>
                                <div class="val2B text-center pt-0" :style="`width: ${widthValDouble2}%;color:#9a9a9a;`">B</div>
                                <div class="val3C text-center pt-0" :style="`width: ${widthValDouble3}%`">C</div>
                                <div class="val4D text-center pt-0" :style="`width: ${widthValDouble4}%;color:#9a9a9a;`">D</div>
                                <div class="val5E text-center pt-0" :style="`width: ${widthValDouble5}%`">E</div>
                              </v-row>
                              <v-row>
                                <v-col
                                    cols="12"
                                    md="4"
                                >
                                  <v-text-field
                                      v-model="drawingDoubleValue1"
                                      type="number"
                                      @change="calcDrawing('double1', drawingDoubleValue1, $event.currentTarget);"
                                      prefix="A"
                                      :min="minWidthDouble"
                                      :max="maxWidthDouble"
                                      suffix="mm"
                                      required
                                      dense
                                      solo
                                  ></v-text-field>
                                </v-col>

                                <v-col
                                    cols="12"
                                    md="4"
                                >
                                  <v-text-field
                                      v-model="drawingDoubleValue3"
                                      type="number"
                                      prefix="C"
                                      suffix="mm"
                                      @change="calcDrawing('double3', drawingDoubleValue3);"
                                      :min="minWidthDouble"
                                      :max="maxWidthDouble"
                                      required
                                      dense
                                      solo
                                  ></v-text-field>
                                </v-col>

                                <v-col
                                    cols="12"
                                    md="4"
                                >
                                  <v-text-field
                                      v-model="drawingDoubleValue5"
                                      type="number"
                                      prefix="E"
                                      suffix="mm"
                                      @change="calcDrawing('double5', drawingDoubleValue5)"
                                      :min="minWidthDouble"
                                      :max="maxWidthDouble"
                                      required
                                      dense
                                      solo
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-alert type="info" v-if="minMaxAlert" dense>
                                {{ minMaxAlert }}
                              </v-alert>
                              <v-row justify="center">
                                <v-col
                                    cols="12"
                                    md="2"
                                >
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="4"
                                >
                                  <v-text-field
                                      v-model="drawingDoubleValue2"
                                      type="number"
                                      prefix="B"
                                      suffix="mm"
                                      required
                                      dense
                                      solo-inverted
                                      disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="4"
                                >
                                  <v-text-field
                                      v-model="drawingDoubleValue4"
                                      type="number"
                                      prefix="D"
                                      suffix="mm"
                                      required
                                      dense
                                      solo-inverted
                                      disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="2"
                                >
                                </v-col>
                              </v-row>
                            </v-container>

                          </div>

                        </div>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                              elevation="2"
                              x-small
                              v-if="a.value && index != Object.keys(n.accordion).length - 1"
                              color="primary"
                              @click="nextPanel(index)"
                          >
                            {{ buttons.next }}
                          </v-btn>
                          <v-btn
                              elevation="2"
                              x-small
                              disabled
                              v-else-if="!a.value && index != Object.keys(n.accordion).length - 1"
                          >
                            Maak uw keuze
                          </v-btn>
                        </v-card-actions>
                      </v-expansion-panel-content>
                    </template>

                  </v-expansion-panel>
                </v-expansion-panels>

                <!-- If last step don't make accordion but a multiple readonly with tables -->
                <v-expansion-panels
                    multiple
                    v-else
                    v-model="recap"
                >
                  <v-expansion-panel
                      v-for="step in stepperSteps.slice(0, -1)"
                      :key="step.number"
                  >
                    <v-expansion-panel-header><strong v-if="step.name">{{step.number}}. {{step.name}}</strong></v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <p v-if="step.intro">{{ step.intro }}</p>
                      <div
                          v-for="option in step.accordion"
                          :key="option.name"
                      >
                        <v-simple-table class="recap--table" dense>
                          <template v-slot:default>
                            <tbody>
                            <tr
                                v-for="item in option.items"
                                :key="item.title"
                            >
                              <template
                                  v-if="item.title !== findElement.widthAntislipmatGraduatedPrice.Item && item.title !== findElement.widthGraduatedPrice.Item && item.title !== findElement.depthSidewallGlass.Item && item.title !== findElement.widthDrawerFrontLowGraduatedPrice.Item && item.title !== findElement.widthDrawerFrontHighGraduatedPrice.Item">
                                <td class="recap--table--title recap--table--td"><strong>{{ item.title }}</strong></td>
                                <td v-if="item.selectedLabel" class="recap--table--value recap--table--td">{{ item.selectedLabel }}</td>
                                <td v-else class="recap--table--value recap--table--td">{{ item.value }}</td>
                                <td v-if="item.selectedPrice" class="recap--table--price recap--table--td" width="10" align="right">
                                  <template v-if="item.type !== 'radio-cat' && item.type !== 'radio-subcat'">
                                    {{formatPrice(item.selectedPrice)}}
                                  </template>
                                </td>
                                <td v-else class="recap--table--price recap--table--td" align="right">{{formatPrice(0)}}</td>
                              </template>
                            </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <div class="table-total">Totaal: <strong>{{formatPrice(duoHeaderCartItems.value)}}</strong></div>
                  <div class="addAmountToCart">
                    <v-row class="align-center">
                      <v-col cols="8" class="addAmountToCart-label">
                        Aantal toevoegen aan winkelwagen:
                      </v-col>
                      <v-col cols="4" class="addAmountToCart-input">
                        <v-text-field
                            v-model='addAmountToCart'
                            placeholder="0"
                            type="number"
                            dense
                            outlined
                            v-bind:class="{ 'no-input-yet' : !(addAmountToCart > 0) }"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </div>


                </v-expansion-panels>

                <div
                    v-for="a in n.accordion"
                    :key="`${a.name}-itemmm`">
                  <div
                      v-for="item in a.items"
                      :key="`${item.title}-item`"
                      class="staffelprijs-radiobutton"
                  >
                    <!-- specific for the Breedte Staffelprijs -->
                    <template v-if="item.title === findElement.widthGraduatedPrice.Item">
                      <div
                          class="d-none">
                        <div
                            v-for="opt in item.options"
                            v-bind:key="opt.label">
                          <strong>{{item.title}}</strong>
                          <label :for="`width${opt.label}`" :key="opt.label">
                            <input type="radio" :id="`width${opt.label}`" name="breedteStaffelprijs"
                                   :value="Number(opt.label)"
                                   v-model="item.value"
                                   :key="opt.label"
                                   v-on:change="item.selectedPrice = opt.price + item.price; item.valCode = opt.valCode; item.selectedLabel = opt.label; item.value = opt.value;"
                                   :data-breedtestaffelprijs="Number(opt.label)"
                            > <span>{{opt.label}}</span>
                          </label>
                        </div>
                      </div>
                    </template>

                    <!-- specific for the Antislipmat Staffelprijs -->
                    <template v-if="item.title === findElement.widthAntislipmatGraduatedPrice.Item">
                      <div
                          class="d-none">
                        <div
                            v-for="opt in item.options"
                            v-bind:key="opt.label">
                          <strong>{{item.title}}</strong>
                          <label :for="`widthAntislipmat${opt.label}`" :key="opt.label">
                            <input type="radio" :id="`widthAntislipmat${opt.label}`" name="antislipmatStaffelprijs"
                                   :value="Number(opt.label)"
                                   v-model="item.value"
                                   :key="opt.label"
                                   v-on:change="item.selectedPrice = opt.price + item.price; item.valCode = opt.valCode; item.selectedLabel = opt.label; item.value = opt.value;"
                                   :data-antislipmatstaffelprijs="Number(opt.label)"
                            > <span>{{opt.label}}</span>
                          </label>
                        </div>
                      </div>
                    </template>

                    <!-- specific for the Zijwand glas (staffelprijs) -->
                    <template v-if="item.title === findElement.depthSidewallGlass.Item">
                      <div
                          class="d-none">
                        <strong>{{item.title}}</strong>
                        <div
                            v-for="opt in item.options"
                            v-bind:key="opt.label"
                        >
                          <label :for="`depthZijwandglas${opt.label}`" :key="opt.label">
                            <input type="radio" :id="`depthZijwandglas${opt.label}`" name="zijwandglasStaffelprijs"
                                   :value="Number(opt.label)"
                                   v-model="item.value"
                                   :key="opt.label"
                                   v-on:change="item.selectedPrice = opt.price + item.price; item.valCode = opt.valCode; item.selectedLabel = opt.label; item.value = opt.value;"
                                   :data-zijwandglasstaffelprijs="Number(opt.label)"
                            > <span>{{opt.label}}</span>
                          </label>
                        </div>
                      </div>
                    </template>

                    <!-- specific for the Binnenlade Front laag (staffelprijs) -->
                    <template v-if="item.title === findElement.widthDrawerFrontLowGraduatedPrice.Item">
                      <div
                          class="d-none">
                        <strong>{{item.title}}</strong>
                        <div
                            v-for="opt in item.options"
                            v-bind:key="opt.label"
                        >
                          <label :for="`widthBinnenladeGlasLaag${opt.label}`" :key="opt.label">
                            <input type="radio" :id="`widthBinnenladeGlasLaag${opt.label}`" name="binnenladeglasLaagStaffelprijs"
                                   :value="Number(opt.label)"
                                   v-model="item.value"
                                   :key="opt.label"
                                   v-on:change="item.selectedPrice = opt.price + item.price; item.valCode = opt.valCode; item.selectedLabel = opt.label; item.value = opt.value;"
                                   :data-binnenladeglaslaagstaffelprijs="Number(opt.label)"
                            > <span>{{opt.label}}</span>
                          </label>
                        </div>
                      </div>
                    </template>

                    <!-- specific for the Binnenlade Front laag (staffelprijs) -->
                    <template v-if="item.title === findElement.widthDrawerFrontHighGraduatedPrice.Item">
                      <div
                          class="d-none">
                        <strong>{{item.title}}</strong>
                        <div
                            v-for="opt in item.options"
                            v-bind:key="opt.label"
                        >
                          <label :for="`widthBinnenladeGlasLaag${opt.label}`" :key="opt.label">
                            <input type="radio" :id="`widthBinnenladeGlasHoog${opt.label}`" name="binnenladeglasHoogStaffelprijs"
                                   :value="Number(opt.label)"
                                   v-model="item.value"
                                   :key="opt.label"
                                   v-on:change="item.selectedPrice = opt.price + item.price; item.valCode = opt.valCode; item.selectedLabel = opt.label; item.value = opt.value;"
                                   :data-binnenladeglashoogstaffelprijs="Number(opt.label)"
                            > <span>{{opt.label}}</span>
                          </label>
                        </div>
                      </div>
                    </template>

                  </div>
                </div>

              </v-container>
            </div>
          </div>
        </div>

        <v-card-actions class="pb-6">
          <v-spacer></v-spacer>
          <v-btn
              v-if="Number(n.number) > 1 "
              @click="prevStep(Number(n.number))"
              text>
            {{ buttons.prev }}
          </v-btn>
          <v-btn
              v-if="Number(n.number) < stepperSteps.length"
              color="primary"
              @click="nextStep(Number(n.number))"
              :disabled="!stepperSteps[n.number - 1].value"
          >
            {{ buttons.nextStep }}
          </v-btn>
          <v-btn
              v-else
              @click="onCartAdd(); onCartAddLoading = true;"
              color="primary"
              :disabled="!(addAmountToCart > 0) || onCartAddLoading"
          >
            {{ buttons.completed }} <v-progress-circular
              indeterminate
              :size="15"
              :width="2"
              color="primary"
              style="margin-left:5px;"
              v-if="onCartAddLoading"
          >
          </v-progress-circular>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-stepper-content>
    </v-stepper-items>
    <v-dialog
        v-model="dialogLargeimage"
        max-width="1072"
        style='z-index:9001;'
    >
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-icon icon
                  small
                  color="primary"
                  class="icon-tooltip"
                  @click="dialogLargeimage = false"
          >
            {{ svgPath.closeIcon }}
          </v-icon>
        </v-card-actions>
        <v-card-text class="text-center">
          <img :src="imgURLcomputed" v-if="imgURLcomputed" @error="imgURLcomputed=imgFallback+imgURLcomputedFilename" class="productImage productImageComputed" />
          <img :src="imgURLstart" v-else class="productImage productImageStart" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

var breedtestaffelprijsTimeout = '';
var showErrorTimeout = '';
var breedteAntislipmatstaffelprijsTimeout = '';
var diepteVoorwandglasstaffelprijsTimeout = '';
var diepteZijwandglasstaffelprijsTimeout = '';
/* eslint-disable no-unused-vars */

import { mdiCheckCircle } from '@mdi/js';
import { mdiCloseThick } from '@mdi/js';
import { mdiCommentQuestion } from '@mdi/js';
import axios from 'axios';
import stepperCart from '../stepperCart';
import mountedMethod from '../mountedMethod';
import envData from '../envData';
/* eslint-disable no-unused-vars */

export default {
  data() {
    return {
      ...envData,
      cartArray: [],
      imgURL: '/custom/plugins/KienerDuo/app/dist/static/assets/',
      imgURLcomputed: '',
      imgURLcomputedFilename: '',
      imgURLstart: '/custom/plugins/KienerDuo/app/dist/static/assets/BLLG.jpg',
      imgFallback: 'http://via.placeholder.com/500x500/EFEFEF/999999/?text=',
      selectedProductId: "",
      selectedProductNumber: "",
      noExtraLoadCapacityBelowDepth: 450,
      forceExtraLoadCapacityFromDepth: 650,
      noSideGlassBelowDepth: 350,
      minWidthSlider: 480,
      heightLoader: false,
      currentHash: "",
      addAmountToCart: '',
      onCartAddLoading: false,
      dialogLargeimage: false,
      DrawerRunnerImgUrl: '',
      DrawerRunnerImgBrandLegra: 'LEGRABOX_GELEIDERS_',
      DrawerRunnerImgBrandTandem: 'ANTARO_GELEIDERS_',
      DrawerRunnerImgSuffixBlumotion: 'A',
      DrawerRunnerImgSuffixTiponBlumotion: 'B',
      findElement: {
        widthGraduatedPrice: {
          Step: 3,
          Accordion: "Binnenwerkse kastbreedte",
          Item: "Breedte (staffelprijs)"
        },
        widthAntislipmatGraduatedPrice: {
          Step: 4,
          Accordion: "Antislipmat",
          Item: "Antislipmat (staffelprijs)"
        },
        widthDrawerFrontLowGraduatedPrice: {
          Step: 4,
          Accordion: "Front",
          Item: "Binnenlade Front laag (staffelprijs)"
        },
        widthDrawerFrontHighGraduatedPrice: {
          Step: 4,
          Accordion: "Front",
          Item: "Binnenlade Front hoog (staffelprijs)"
        },
        sidewallGlassSelected: {
          Step: 4,
          Accordion: "Zijwand",
          Item: "Zijwand glas",
          IfSelected: "Ja"
        },
        depthSidewallGlass: {
          Step: 4,
          Accordion: "Zijwand",
          Item: "Zijwand glas (staffelprijs)"
        },
        LoadCapacity: {
          Step: 3,
          Accordion: "Diepte",
          Item: "Extra draagvermogen"
        },
        depth: {
          Step: 3,
          Accordion: "Diepte",
          Item: "Ladediepte",
        },
        typeCutout: {
          Step: 2,
          Accordion: "Type uitsparing",
          Item: "Type uitsparing"
        },
        slider: {
          Step: 3,
          Accordion: "Binnenwerkse kastbreedte",
          Item: "Binnenwerkse kastbreedte",
          Type: "slider"
        },
        drawerFront: {
          Step: 4,
          Accordion: "Front",
          Item: "Binnenlade Front",
          IfSelectedMetal: "Metaal",
          IfSelectedGlass: "Glas",
          IfSelectedGlassLow: "Glas (laag)",
          IfSelectedGlassHigh: "Glas (hoog)"
        },
        typeDrawerRunner: {
          Step: 2,
          Accordion: "Type ladegeleider",
          Item: "Type ladegeleider",
          IfSelectedBlumotion: "Blumotion",
          IfSelectedTiponBlumotion: "Tip-on+Blumotion"
        },
        drawerDriver: {
          Step: 4,
          Accordion: "Front",
          Item: "Meenemer"
        },
        FilllistLeft: {
          Step: 4,
          Accordion: "Opvullijst",
          Item: "Opvullijst (links)",
          IfSelected: "Ja"
        },
        FilllistRight: {
          Step: 4,
          Accordion: "Opvullijst",
          Item: "Opvullijst (rechts)",
          IfSelected: "Ja"
        },
        FilllistColor: {
          Step: 4,
          Accordion: "Opvullijst",
          Item: "Kleur opvullijst"
        },
        Antislipmat: {
          Step: 4,
          Accordion: "Antislipmat",
          Item: "Antislipmat Kleur",
          IfNotSelected: "Geen antislipmat"
        },
        drawing: {
          Step: 3,
          Accordion: "Verdeling uitsparingen",
          Type: "drawing"
        }
      },
      step1Brand: "",
      step1Type: "",
      step1TypeProductID: "",
      step1Height: "",
      step1HeightproductID: "",
      step1ImgURL: "",
      duoHeaderCartItems: {
        qty: 0,
        value: 0
      },
      OptionsSelected: {
        typeSifon: "single",
        depth: '',
        showLoadCapacity: false,
        forceLoadCapacity: false,
        showSidewallGlass: false,
        showFilllistColor: false,
        showDriver: false,
        minSifonWidthS: 160,
        minSifonWidthL: 300,
        IsAntislipmatSelected: false,
        IsSidewallGlassSelected: false,
      },
      EmptyLabel: "Maak hier uw keuze...",
      EmptyPlaceholder: "Vul uw waarde in",
      catLadeOpMaat: [],
      catLadeOpMaatDetail: [],
      subLadeOpMaatCat: [],
      subLadeOpMaatCatInfo: [],
      selectedBrand: "",
      selectedType: "",
      BinnenwerkseKastbreedte: "",
      loadingSubsteps: true,
      LoadingCustomProducts: true,
      stepperSteps: this.steps,
      CustomFieldsSteps: [],
      calcDrawingEvent: '',
      svgPath: {
        CheckCircleOn: mdiCheckCircle,
        closeIcon: mdiCloseThick,
        help: mdiCommentQuestion
      },
      panel: 0,
      recap: [],
      polygonPoints: "0.8,0.8" + " " +
          "0.8,26.627" + " " +
          "100.801,26.627" + " " +
          "100.801,0.8" + " " +
          "65.21,0.8" + " " +
          "65.21,16.627" + " " +
          "44.264,16.627" + " " +
          "44.264,0.8",
      polygonPointsDouble: "0.8,0.8" + " " +
          "0.8,26.627" + " " +
          "100.801,26.627" + " " +
          "100.801,0.8" + " " +
          "80,0.8" + " " +
          "80,16.627" + " " +
          "60,16.627" + " " +
          "60,0.8" + " " +
          "40,0.8" + " " +
          "40,16.627" + " " +
          "20,16.627" + " " +
          "20,0.8",
      dottedLineWidth: "0.5",
      drawingValue1: 120,
      drawingValue2: 160,
      drawingValue3: 120,
      drawingDoubleValue1: 120,
      drawingDoubleValue2: 160,
      drawingDoubleValue3: 120,
      drawingDoubleValue4: 160,
      drawingDoubleValue5: 120,
      drawingValueTotal: '',
      fullWidthDrawing: 400,
      minMaxAlert: '',
      minWidthLeft: 120,
      maxWidthLeft: 1000,
      minWidthRight: 120,
      maxWidthRight: 1000,
      minWidthDouble: 120,
      maxWidthDouble: 100,
      fixedValue1: "16.26",
      fixedValue2: "50.4",
      fixedValue3: "84.344",
      fixedValueDouble1: "10",
      fixedValueDouble2: "30",
      fixedValueDouble3: "50",
      fixedValueDouble4: "70",
      fixedValueDouble5: "90",
      widthVal1: 33,
      widthVal2: 33,
      widthVal3: 33,
      widthValDouble1: 20,
      widthValDouble2: 20,
      widthValDouble3: 18.6,
      widthValDouble4: 20,
      widthValDouble5: 19,
      lineVal1: "45.478,0 45.478,2.504 0.8,2.504 0.8,0",
      lineVal3: "100.801,0 100.801,2.504 65.427,2.504 65.427,0",
      lineVal2x1: "65.427",
      lineVal2x2: "45.478",
      lineValDouble1: "20,0 20,2.504 0.8,2.504 0.8,0",
      lineValDouble2x1: "40",
      lineValDouble2x2: "20",
      lineValDouble3: "60,0 60,2.504 40,2.504 40,0",
      lineValDouble4x1: "60",
      lineValDouble4x2: "80",
      lineValDouble5: "100,0 100,2.504 80,2.504 80,0"
    }
  },
  props: ['steps', 'stepPrefix', 'buttons'],
  computed: {
    sendCartvalueToParent() {
      // if this below changes send whole duoHeaderCartItems back to parrent
      return this.duoHeaderCartItems.value;
    },
    step1ImgURLComp() {
      return this.step1ImgURLComp;
    },
    selectedTypeHeights: function () {
      function dynamicSort(property) {
        var sortOrder = 1;
        if(property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
        }
        return function (a,b) {
          /* next line works with strings and numbers,
           * and you may want to customize it to your needs
           */
          var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
          return result * sortOrder;
        }
      }
      var newHeightItems = [];
      // `this` points to the vm instance
      const heightItems = this.stepperSteps[0].accordion[2].items[0].options;
      for (var a = 0; a < heightItems.length; a++) {
        if (heightItems[a].parentId === this.selectedType) {
          newHeightItems.push(heightItems[a]);
        }
      }
      newHeightItems.sort(dynamicSort("label"));

      return newHeightItems;
    }
  },
  watch: {
    stepperSteps: {
      handler: function (val) {
        // update the changes in the localStorage
        localStorage.steps = JSON.stringify(val);
        this.changeOptionSelection();
      },
      deep: true
    },
    sendCartvalueToParent() {
      this.$emit('update:cartItems', this.duoHeaderCartItems);
    },
    step1HeightproductID: function (val) {
      localStorage.step1HeightproductID = val;
    },
    step1TypeProductID: function(val) {
      localStorage.step1TypeProductID = val;
    },
    step1Brand: function (val) {
      var HeightSep = '';
      var TypeSep = '';
      if(this.step1Height.length > 0) {
        HeightSep = '_' + this.step1Height;
      }
      if(this.step1Type.length > 0) {
        TypeSep = '_' + this.step1Type;
      }
      this.step1ImgURL = val + HeightSep + TypeSep;
    },
    step1Height: function (val) {
      var BrandSep = '';
      var HeightSep = '';
      var TypeSep = '';
      if(this.step1Brand.length > 0) {
        BrandSep = this.step1Brand;
      }
      if(val.length > 0) {
        HeightSep = '_' + this.step1Height;
      }
      if(this.step1Type.length > 0) {
        TypeSep = '_' + this.step1Type;
      }
      this.step1ImgURL = BrandSep + HeightSep + TypeSep;
    },
    step1Type: function (val) {
      var BrandSep = '';
      var HeightSep = '';
      var TypeSep = '';
      if(val.length > 0) {
        TypeSep = '_' + val;
      }
      if(this.step1Brand.length > 0) {
        BrandSep = this.step1Brand;
      }
      if(this.step1Height.length > 0) {
        HeightSep = '_' + this.step1Height;
      }
      this.step1ImgURL = BrandSep + HeightSep + TypeSep;
    },
  },
  methods: {
    indexCalc(index) {
      if(index > 0) {
        return index - 1;
      } else {
        return index;
      }
    },
    clearCacheStepper() {
      window.localStorage.removeItem('subLadeOpMaatCatInfo');
      window.localStorage.removeItem('subLadeOpMaatCat');
      window.localStorage.removeItem('catLadeOpMaatDetail');
      window.localStorage.removeItem('preSteps');
      window.localStorage.removeItem('steps');
      window.localStorage.removeItem('currentStep');
      window.localStorage.removeItem('totalprice');

      window.localStorage.removeItem('selectedBrand');
      window.localStorage.removeItem('step1HeightproductID');
      window.localStorage.removeItem('step1Height');
      window.localStorage.removeItem('step1TypeProductID');
      window.localStorage.removeItem('step1Type');
      window.localStorage.removeItem('step1Brand');
      window.localStorage.removeItem('step1productID');
      location.reload(true);
      //window.location.href
    },
    setMinMaxInput() {
      var thisVar = this;
      const slider = this.findItem(this.findElement.slider);
      if(!slider) return

      if(!slider.value) return
      if (slider.value < Number(thisVar.minWidthSlider)) {
        slider.value = Number(thisVar.minWidthSlider);
      } else if (slider.value > Number(slider.rangeMax)) {
        slider.value = Number(slider.rangeMax);
      }

      thisVar.calcDrawing('middle', thisVar.drawingValue3, 'sliderclick');
      thisVar.changeWidthPrice(slider.value);
      thisVar.setFullWidth(slider.value);
      slider.selectedLabel = slider.value + ' mm';
      thisVar.checkIsItemDisabled();
    },
    setValueOfDrawing() {
      var thisVar = this;

      const foundOption = this.findOption(this.findElement.typeCutout);
      if(!foundOption) return

      const foundValCode = foundOption.valCode;
      if (foundValCode === '2S' || foundValCode === '2L') {
        this.drawingValueTotal = this.drawingDoubleValue1 + '-' + this.drawingDoubleValue2 + '-' + this.drawingDoubleValue3 + '-' + this.drawingDoubleValue4 + '-' + this.drawingDoubleValue5;
      } else if(foundValCode === '1S' || foundValCode === '1L') {
        this.drawingValueTotal = this.drawingValue1 + '-' + this.drawingValue2 + '-' + this.drawingValue3;
      }

      const drawingAccordion = thisVar.findAccordion(thisVar.findElement.drawing);
      const drawing = thisVar.findType(thisVar.findElement.drawing);
      if(!drawing) return

      drawingAccordion.value = "[" + this.drawingValueTotal + "]";
      drawing.value = this.drawingValueTotal;
      drawing.selectedLabel = this.drawingValueTotal;
    },
    nextStep(n) {
      this.$emit('clickednext', n);

      // open first panel
      this.panel = 0;

      //Get configuratation from customproducts
      this.saveConfig();
    },
    prevStep(n) {
      this.$emit('clickedprev', n)
    },
    ...stepperCart,
    nextPanel(panelNumber) {
      this.panel = panelNumber + 1;
    },
    formatPrice(val) {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(val);
    },
    openAllRecap() {
      // open al recap panels
      this.recap = [...Array(this.stepperSteps.length).keys()].map((k, i) => i)
    },
    setSelectedCat(newSelected) {
      this.selectedBrand = newSelected;
      localStorage.selectedBrand = this.selectedBrand;
    },
    ifIsColor(color) {
      var colorBooleans = color.startsWith("#");
      return colorBooleans;
    },
    ifEmptyLabel(label) {
      if(label) {
        return label;
      } else {
        return this.EmptyLabel;
      }
    },
    ifEmptyPlaceholder(placeholder) {
      if(placeholder) {
        return placeholder;
      } else {
        return this.EmptyPlaceholder;
      }
    },
    checkIfAccordionHasAllValues() {
      var thisVar = this;

      function hasSelectedLabel(currentValue) {
        if(!currentValue.selectedLabel) return
        return currentValue.selectedLabel.length > 0;
      }

      if(!thisVar.stepperSteps) return

      for (var a = 0; a < thisVar.stepperSteps.length; a++) {

        // loop through all the accordions
        var AccordionArray = thisVar.stepperSteps[a].accordion;
        if(!AccordionArray) return

        for (var b = 0; b < AccordionArray.length; b++) {
          var valueArray = [];

          //loop through all items
          var itemsArray = thisVar.stepperSteps[a].accordion[b].items;
          if(!itemsArray) return

          for (var c = 0; c < itemsArray.length; c++) {
            // Value summery build
            if (itemsArray[c].value && !itemsArray[c].title.includes("(staffelprijs)")) {
              valueArray = valueArray + '[' + itemsArray[c].selectedLabel + '] ';
            }

            if(!valueArray) return

            if(valueArray.length > 0 && itemsArray.every(hasSelectedLabel)) {
              thisVar.stepperSteps[a].accordion[b].value = valueArray;
            }

          }

        }

      }

    },
    checkIfAllAccordionsHasValues() {
      // For next slide button
      var thisVar = this;

      function hasSelectedLabel(currentValue) {
        if(!currentValue.value) return
        return currentValue.value.length > 0;
      }

      if(!thisVar.stepperSteps) return

      for (var a = 0; a < thisVar.stepperSteps.length; a++) {

        // loop through all the accordions
        var AccordionArray = thisVar.stepperSteps[a].accordion;
        if(!AccordionArray) return
        var valueArray = [];

        for (var b = 0; b < AccordionArray.length; b++) {

          // Value summery build
          if (AccordionArray[b].value) {
            valueArray = valueArray + '[' + AccordionArray[b].value + '] ';
          }

          if(!valueArray) return

          if(valueArray.length > 0 && AccordionArray.every(hasSelectedLabel)) {
            thisVar.stepperSteps[a].value = valueArray;
          }

        }

      }

    },
    clearOptions() {
      var thisVar = this;
      thisVar.step1Type = "";
      thisVar.step1Height = "";
      thisVar.DrawerRunnerImgUrl = "";
      thisVar.stepperSteps = this.steps;
      thisVar.stepperSteps[0].value = '';
    },
    changeWidthPrice(width) {
      this.BinnenwerkseKastbreedte = width;
    },
    setFullWidth(width) {
      this.fullWidthDrawing = width;
      const slider = this.findAccordion(this.findElement.slider);
      slider.value = '[' + width + ' mm]';
    },
    drawerFrontType() {
      var thisVar = this;

      this.setStaffelPriceFunction(thisVar.findElement.widthDrawerFrontLowGraduatedPrice, thisVar.findElement.widthDrawerFrontHighGraduatedPrice, 'data-binnenladeglaslaagstaffelprijs', 'data-binnenladeglashoogstaffelprijs');

      const frontTypeOptionValueLabel = this.findOption(thisVar.findElement.drawerFront);
      if(!frontTypeOptionValueLabel) return

      if(frontTypeOptionValueLabel.label === thisVar.findElement.drawerFront.IfSelectedMetal) {
        thisVar.OptionsSelected.showDriver = true;
      } else {
        thisVar.OptionsSelected.showDriver = false;
      }

    },
    setStaffelPriceFunction(itemLow, itemHigh, dataelementLow, dataelementHigh) {
      var thisVar = this;
      var strippedOptions = new Map();
      var strippedOptionsHigh = new Map();

      const ItemArray = thisVar.findItem(itemLow);

      const ItemArrayHigh = thisVar.findItem(itemHigh);
      if(!ItemArrayHigh) return

      // Create new array with only the labels
      if(ItemArray) {
        for (let i = 0; i < ItemArray.options.length; i++) {
          strippedOptions.set(Number(ItemArray.options[i].label), Number(ItemArray.options[i].price));
        }
      }

      for(let i = 0; i < ItemArrayHigh.options.length; i++){
        strippedOptionsHigh.set(Number(ItemArrayHigh.options[i].label), Number(ItemArrayHigh.options[i].price));
      }

      if(!strippedOptionsHigh) return

      function getClosestValue(myArray, myValue){
        //optional
        var i = 0;
        while(myArray[++i] <= myValue);
        return myArray[--i];
      }

      if(ItemArray) {
        let keys = [...strippedOptions.keys()];
        var staffel = getClosestValue(keys, this.BinnenwerkseKastbreedte);
        var staffelPrice = strippedOptions.get(staffel);
      }

      let keysHigh = [...strippedOptionsHigh.keys()];
      var staffelHigh = getClosestValue(keysHigh, this.BinnenwerkseKastbreedte);
      const staffelHighPrice = strippedOptionsHigh.get(staffelHigh);

      // Set price on the pricelabel for the user to see
      const drawerfront = thisVar.findItem(thisVar.findElement.drawerFront);
      if(ItemArray) {
        drawerfront.options[1].price = staffelPrice;
        drawerfront.options[2].price = staffelHighPrice;
      } else {
        drawerfront.options[1].price = staffelHighPrice;
      }

      clearTimeout(diepteVoorwandglasstaffelprijsTimeout);

      const frontTypeOptionValueLabel = this.findOption(thisVar.findElement.drawerFront);
      if(!frontTypeOptionValueLabel) return

      // set time out so you have time to put a number in. If you want to say 900 it isn't checking right after you hit the 9 and give a error right away
      diepteVoorwandglasstaffelprijsTimeout = setTimeout(function() {

        if(frontTypeOptionValueLabel.label === thisVar.findElement.drawerFront.IfSelectedGlassLow) {
          document.querySelector(`[${dataelementLow}="${staffel}"]`).click();
          document.querySelector(`[${dataelementHigh}="0"]`).click();
        } else if(frontTypeOptionValueLabel.label === thisVar.findElement.drawerFront.IfSelectedGlassHigh) {
          document.querySelector(`[${dataelementHigh}="${staffelHigh}"]`).click();
          document.querySelector(`[${dataelementLow}="0"]`).click();
        } else if(frontTypeOptionValueLabel.label === thisVar.findElement.drawerFront.IfSelectedGlass) {
          document.querySelector(`[${dataelementHigh}="${staffelHigh}"]`).click();
          document.querySelector(`[${dataelementLow}="0"]`).click();
        } else if(frontTypeOptionValueLabel.label === thisVar.findElement.drawerFront.IfSelectedMetal) {
          document.querySelector(`[${dataelementHigh}="0"]`).click();
          document.querySelector(`[${dataelementLow}="0"]`).click();
        }

        if(frontTypeOptionValueLabel.label === thisVar.findElement.drawerFront.IfSelectedGlassLow || frontTypeOptionValueLabel.label === thisVar.findElement.drawerFront.IfSelectedGlassHigh || frontTypeOptionValueLabel.label === thisVar.findElement.drawerFront.IfSelectedGlass) {
          const drawer = thisVar.findItem(thisVar.findElement.drawerDriver);
          drawer.value = drawer.options[0].value;
          drawer.selectedLabel = drawer.options[0].label;
        }

      }, 500);
    },
    checkDepthSelection() {
      var thisVar = this;

      const depthOption = this.findOption(thisVar.findElement.depth);

      if(!depthOption) return
      if(!depthOption.label) return

      // Get only the first word
      var depthOptionLabel = depthOption.label.replace(/ .*/,'');
      // Get only the numbers
      depthOptionLabel = depthOptionLabel.replace(/\D/g, "");

      // set value op depth on selection
      this.OptionsSelected.depth = depthOptionLabel;

      // Empty Extra Draagvermogen value
      if(thisVar.OptionsSelected.depth < thisVar.noExtraLoadCapacityBelowDepth) {
        thisVar.OptionsSelected.showLoadCapacity = false;
        const loadCapacity = thisVar.findItem(thisVar.findElement.LoadCapacity);
        if(!loadCapacity) return
        loadCapacity.value = loadCapacity.options[0].value;
        loadCapacity.selectedLabel = loadCapacity.options[0].label;
      } else {
        thisVar.OptionsSelected.showLoadCapacity = true;
      }

      // Force extra load above number
      if(thisVar.OptionsSelected.depth >= thisVar.forceExtraLoadCapacityFromDepth) {
        thisVar.OptionsSelected.forceLoadCapacity = true;
        const loadCapacity = thisVar.findItem(thisVar.findElement.LoadCapacity);
        if(!loadCapacity) return
        loadCapacity.value = loadCapacity.options[1].value;
        loadCapacity.selectedLabel = loadCapacity.options[1].label;
      } else {
        thisVar.OptionsSelected.forceLoadCapacity = false;
      }


      if(thisVar.OptionsSelected.depth < thisVar.noSideGlassBelowDepth) {
        thisVar.OptionsSelected.showSidewallGlass = false;
        const sidewallGlassSelect = thisVar.findItem(thisVar.findElement.sidewallGlassSelected);
        if(!sidewallGlassSelect) return
        sidewallGlassSelect.value = sidewallGlassSelect.options[0].value;
        sidewallGlassSelect.selectedLabel = sidewallGlassSelect.options[0].label;
      } else {
        thisVar.OptionsSelected.showSidewallGlass = true;
      }

      //Set staffelprijs Glas
      this.setStaffelPrijsGlas(thisVar.OptionsSelected.depth);

    },
    setStaffelPrijsGlas(depth) {
      var thisVar = this;
      var strippedOptions = new Map();

      const glassstaffelprijsItem = thisVar.findItem(thisVar.findElement.depthSidewallGlass);
      if(!glassstaffelprijsItem) return

      // Create new array with only the labels
      for(let i = 0; i < glassstaffelprijsItem.options.length; i++){
        strippedOptions.set(Number(glassstaffelprijsItem.options[i].label), Number(glassstaffelprijsItem.options[i].price));
      }

      if(!strippedOptions) return

      function getClosestValue(myArray, myValue){
        //optional
        var i = 0;
        while(myArray[++i] <= myValue);
        return myArray[--i];
      }

      let keys = [...strippedOptions.keys()];
      var staffel = getClosestValue(keys, depth);
      const staffelPrice = strippedOptions.get(staffel);

      // set the price on the price label for the user to see
      const sidewallGlass = thisVar.findItem(thisVar.findElement.sidewallGlassSelected);
      if(!sidewallGlass) return
      sidewallGlass.options[1].price = staffelPrice;

      const sidewallGlassOption = thisVar.findOption(thisVar.findElement.sidewallGlassSelected);
      if(!sidewallGlassOption) return

      // Get only the first word
      var sidewallGlassOptionLabel = sidewallGlassOption.label.trim();

      if(!sidewallGlassOptionLabel) return

      if(sidewallGlassOptionLabel === thisVar.findElement.sidewallGlassSelected.IfSelected) {
        thisVar.OptionsSelected.IsSidewallGlassSelected = true;
      } else {
        thisVar.OptionsSelected.IsSidewallGlassSelected = false;
      }

      clearTimeout(diepteZijwandglasstaffelprijsTimeout);

      // set time out so you have time to put a number in. If you want to say 900 it isn't checking right after you hit the 9 and give a error right away
      diepteZijwandglasstaffelprijsTimeout = setTimeout(function() {
        if(thisVar.OptionsSelected.IsSidewallGlassSelected) {
          document.querySelector(`[data-zijwandglasstaffelprijs="${staffel}"]`).click();
        } else {
          document.querySelector(`[data-zijwandglasstaffelprijs="0"]`).click();
        }
      }, 500);
    },
    checkIsItemDisabled() {
      var strippedOptions = new Map();
      var thisVar = this;

      const Item = thisVar.findItem(thisVar.findElement.widthGraduatedPrice);
      if(!Item) return
      var options = Item.options;
      if(!options) return

      // Create new array with only the labels
      for(let i = 0; i < Item.options.length; i++){
        strippedOptions.set(Number(Item.options[i].label), Number(Item.options[i].price));
      }

      if(!strippedOptions) return

      function getClosestValue(myArray, myValue){
        //optional
        var i = 0;
        while(myArray[++i] <= myValue);
        return myArray[--i];
      }

      let keys = [...strippedOptions.keys()];
      var staffel = getClosestValue(keys, this.BinnenwerkseKastbreedte);
      const staffelPrice = strippedOptions.get(staffel);

      const slider = thisVar.findType(thisVar.findElement.slider);

      //Set the price in The color selection for the user to see
      slider.StaffelLabel = 'Vanaf ' + staffel + ' mm: ';
      slider.selectedPrice = staffelPrice;

      clearTimeout(breedtestaffelprijsTimeout);

      // set time out so you have time to put a number in. If you want to say 900 it isn't checking right after you hit the 9 and give a error right away
      breedtestaffelprijsTimeout = setTimeout(function() {
        const clickElement = document.querySelector(`[data-breedtestaffelprijs]`);
        if(!clickElement) return
        document.querySelector(`[data-breedtestaffelprijs="${staffel}"]`).click();
      }, 500);

    },
    checkIsItemDisabledAntislipmat() {
      var strippedOptions = new Map();
      var thisVar = this;

      const AntislipmatItem = thisVar.findItem(thisVar.findElement.widthAntislipmatGraduatedPrice);
      if(!AntislipmatItem) return
      const AntislipmatColors = thisVar.findItem(thisVar.findElement.Antislipmat);
      if(!AntislipmatColors) return
      var options = AntislipmatItem.options;
      if(!options) return

      // Create new array with only the labels
      for(let i = 0; i < options.length; i++){
        strippedOptions.set(Number(options[i].label), Number(options[i].price));
      }

      if(!strippedOptions) return

      function getClosestValue(myArray, myValue){
        //optional
        var i = 0;
        while(myArray[++i] <= myValue);
        return myArray[--i];
      }

      let keys = [...strippedOptions.keys()];
      var staffel = getClosestValue(keys, this.BinnenwerkseKastbreedte);
      const staffelPrice = strippedOptions.get(staffel);


      //Set the price in The color selection for the user to see
      for(let i = 0; i < AntislipmatColors.options.length; i++){
        if(i > 0) {
          AntislipmatColors.options[i].price = staffelPrice;
        }
      }

      const AntislipmatOptionValueLabel = thisVar.findOption(thisVar.findElement.Antislipmat);
      if(!AntislipmatOptionValueLabel) return

      clearTimeout(breedteAntislipmatstaffelprijsTimeout);

      if(AntislipmatOptionValueLabel.label !== thisVar.findElement.Antislipmat.IfNotSelected) {
        thisVar.OptionsSelected.IsAntislipmatSelected = true;
      } else {
        thisVar.OptionsSelected.IsAntislipmatSelected = false;
      }

      // set time out so you have time to put a number in. If you want to say 900 it isn't checking right after you hit the 9 and give a error right away
      breedteAntislipmatstaffelprijsTimeout = setTimeout(function() {
        if(thisVar.OptionsSelected.IsAntislipmatSelected) {
          document.querySelector(`[data-antislipmatstaffelprijs="${staffel}"]`).click();
        } else {
          document.querySelector(`[data-antislipmatstaffelprijs="0"]`).click();
        }
      }, 500);

    },
    changeSingleDoubleDrawing() {
      var thisVar = this;

      const itemsifon = thisVar.findItem(thisVar.findElement.typeCutout);
      if(!itemsifon) return
      const itemsifonValCode = itemsifon.valCode;

      if(itemsifonValCode.startsWith("1")) {
        this.OptionsSelected.typeSifon = "single";
      } else if(itemsifonValCode.startsWith("2")) {
        this.OptionsSelected.typeSifon = "double";
      }

      this.setValueOfDrawing();
    },
    changeImageURL() {
      var allValuestogether = 0;
      var allSelectedPrices = 0;
      var IMGSeperator = "_";
      var imgArray = '';
      var thisVar = this;

      // loop through all the steps
      for (var a = 0; a < this.stepperSteps.length; a++) {

        // loop through all the accordions
        var valuesArray = this.stepperSteps[a].accordion;
        for (var b = 0; b < valuesArray.length; b++) {

          //loop through all items
          var itemsArray = this.stepperSteps[a].accordion[b].items;
          for (var c = 0; c < itemsArray.length; c++) {

            // IMG build
            if (itemsArray[c].type !== 'radio-cat' && itemsArray[c].type !== 'radio-subcat' && itemsArray[c].type !== 'radio-subcat-hoogte' && itemsArray[c].valCode !== '') {
              imgArray = imgArray + IMGSeperator + itemsArray[c].valCode;
            }

            // Price build
            // exclude vanaf prijs & staffelprijs
            if (itemsArray[c].type !== 'radio-cat' && itemsArray[c].type !== 'radio-subcat' && itemsArray[c].title !== thisVar.findElement.widthAntislipmatGraduatedPrice.Item && itemsArray[c].title !== thisVar.findElement.widthGraduatedPrice.Item && itemsArray[c].title !== thisVar.findElement.depthSidewallGlass.Item && itemsArray[c].title !== thisVar.findElement.widthDrawerFrontLowGraduatedPrice.Item && itemsArray[c].title !== thisVar.findElement.widthDrawerFrontHighGraduatedPrice.Item) {
              allSelectedPrices = parseFloat(itemsArray[c].selectedPrice);
              allValuestogether = allValuestogether + allSelectedPrices;
            }


          }

        }

        // build the image url and place it in the image box
        this.imgURLcomputed = this.imgURL + this.step1ImgURL + imgArray + '.jpg';
        this.imgURLcomputedFilename = this.step1ImgURL + imgArray + '.jpg';
      }

      // set the calculated price in the footer
      this.duoHeaderCartItems.value = allValuestogether;

      // save the price in the localstorage
      localStorage.totalprice = allValuestogether;
    },
    findAccordion(findElement) {
      var thisVar = this;
      // get the right step
      function findStep(stepperSteps) {
        return stepperSteps.number === findElement.Step;
      }
      function findAccordion(title) {
        return title.name === findElement.Accordion;
      }
      const foundStep = thisVar.stepperSteps.find(findStep);
      if(!foundStep) return
      const foundAccordion = foundStep.accordion.find(findAccordion);
      if(!foundAccordion) return

      return foundAccordion;
    },
    findItem(findElement) {
      var thisVar = this;
      // get the right step
      function findStep(stepperSteps) {
        return stepperSteps.number === findElement.Step;
      }
      function findAccordion(title) {
        return title.name === findElement.Accordion;
      }
      function findItem(title) {
        return title.title === findElement.Item;
      }
      const foundStep = thisVar.stepperSteps.find(findStep);
      if(!foundStep) return
      const foundAccordion = foundStep.accordion.find(findAccordion);
      if(!foundAccordion) return
      const foundItem = foundAccordion.items.find(findItem);
      if(!foundItem) return

      return foundItem;
    },
    findOption(item) {
      const foundItem = this.findItem(item);
      if(!foundItem) return

      function searchOption(value) {
        return value.value === foundItem.value;
      }

      if(!foundItem.options) return
      const foundOption = foundItem.options.find(searchOption);

      return foundOption;
    },
    findType(findElement) {
      var thisVar = this;
      // get the right step
      function findStep(stepperSteps) {
        return stepperSteps.number === findElement.Step;
      }
      function findAccordion(step) {
        return step.name === findElement.Accordion;
      }
      function findType(accordion) {
        return accordion.type === findElement.Type;
      }
      const foundStep = thisVar.stepperSteps.find(findStep);
      if(!foundStep) return
      const foundAccordion = foundStep.accordion.find(findAccordion);
      if(!foundAccordion) return
      const foundItem = foundAccordion.items.find(findType);
      if(!foundItem) return

      return foundItem;
    },
    setMinWidthSlider() {
      var thisVar = this;

      const slider = this.findItem(this.findElement.slider);
      if(!slider) return

      const sliderOriginalMinWidth = slider.rangeMin;
      this.minWidthSlider = sliderOriginalMinWidth;

      const foundOption = this.findOption(this.findElement.typeCutout);
      if(!foundOption) return

      const foundValCode = foundOption.valCode;

      // Blum Legrabox Sifonlade
      if(this.step1Brand === 'BLLG') {
        if (foundValCode === '1S') {
          this.minWidthSlider = sliderOriginalMinWidth;
        } else if (foundValCode === '1L') {
          this.minWidthSlider = 600;
        } else if (foundValCode === '2S') {
          this.minWidthSlider = 717;
        } else if (foundValCode === '2L') {
          this.minWidthSlider = 997;
        }
      }

      //Blum Tandembox Sifonlade
      if(this.step1Brand === 'BLTN') {
        if (foundValCode === '1S' || foundValCode === '1L') {
          this.minWidthSlider = sliderOriginalMinWidth;
        } else if (foundValCode === '2S' || foundValCode === '2L') {
          this.minWidthSlider = 680;
        }
      }

      if(foundValCode === '1S' || foundValCode === '2S') {
        thisVar.drawingDoubleValue2 = thisVar.OptionsSelected.minSifonWidthS;
        thisVar.drawingDoubleValue4 = thisVar.OptionsSelected.minSifonWidthS;
        thisVar.drawingValue2 = thisVar.OptionsSelected.minSifonWidthS;
      }
      if(foundValCode === '1L' || foundValCode === '2L') {
        thisVar.drawingDoubleValue2 = thisVar.OptionsSelected.minSifonWidthL;
        thisVar.drawingDoubleValue4 = thisVar.OptionsSelected.minSifonWidthL;
        thisVar.drawingValue2 = thisVar.OptionsSelected.minSifonWidthL;
      }

      // this.minWidthSlider;
    },
    checkFilllist() {
      var thisVar = this;

      const optionSelectedLeft = thisVar.findOption(thisVar.findElement.FilllistLeft);
      if(!optionSelectedLeft) return
      const optionSelectedRight = thisVar.findOption(thisVar.findElement.FilllistRight);
      if(!optionSelectedRight) return
      const FilllistColor = thisVar.findItem(thisVar.findElement.FilllistColor);
      if(!FilllistColor) return

      if(optionSelectedLeft.label === thisVar.findElement.FilllistLeft.IfSelected || optionSelectedRight.label === thisVar.findElement.FilllistRight.IfSelected) {
        thisVar.OptionsSelected.showFilllistColor = true;
      } else {
        thisVar.OptionsSelected.showFilllistColor = false;
        FilllistColor.value = 'Geen opvullijst';
        FilllistColor.selectedLabel = 'Geen opvullijst';
      }
    },
    drawerRunnerImage() {
      var thisVar = this;
      var brandImgPrefix = '';
      var DrawerRunnerImgSuffix = '';
      const drawerRunnerOption = thisVar.findOption(thisVar.findElement.typeDrawerRunner);
      if(!drawerRunnerOption) return
      if(this.step1Brand === 'BLLG') {
        brandImgPrefix = thisVar.DrawerRunnerImgBrandLegra;
      } else if (this.step1Brand === 'BLTN') {
        brandImgPrefix = thisVar.DrawerRunnerImgBrandTandem;
      }

      if(drawerRunnerOption.label === thisVar.findElement.typeDrawerRunner.IfSelectedBlumotion) {
        DrawerRunnerImgSuffix = thisVar.DrawerRunnerImgSuffixBlumotion;
      } else if(drawerRunnerOption.label === thisVar.findElement.typeDrawerRunner.IfSelectedTiponBlumotion) {
        DrawerRunnerImgSuffix = thisVar.DrawerRunnerImgSuffixTiponBlumotion;
      }

      if(brandImgPrefix && DrawerRunnerImgSuffix) {
        thisVar.DrawerRunnerImgUrl = thisVar.SWURL + thisVar.imgURL + brandImgPrefix + DrawerRunnerImgSuffix + '.jpg';
      } else {
        thisVar.DrawerRunnerImgUrl = '';
      }

    },
    setFirstStepLocalStorage() {
      var thisVar = this;
      localStorage.step1Brand = JSON.stringify(thisVar.step1Brand);
      localStorage.step1Type = JSON.stringify(thisVar.step1Type);
      localStorage.step1Height = JSON.stringify(thisVar.step1Height);
    },
    changeOptionSelection() {
      var thisVar = this;

      //change image url
      thisVar.changeImageURL();

      //Change The type of drawing to single or double
      thisVar.changeSingleDoubleDrawing();

      //Check with Depth is selected
      thisVar.checkDepthSelection();

      //Set staffelprijs width
      thisVar.checkIsItemDisabled();

      //Set the Price for Antislipmat
      thisVar.checkIsItemDisabledAntislipmat();

      //Set the drawerFront
      thisVar.drawerFrontType();

      thisVar.checkFilllist();

      //change the minwidth of the slider
      thisVar.setMinWidthSlider();

      thisVar.drawerRunnerImage();

      //Check if all the values in the accordion are filled
      thisVar.checkIfAccordionHasAllValues();

      //Check if all the values in all the accordions are filled
      thisVar.checkIfAllAccordionsHasValues();

      thisVar.setFirstStepLocalStorage();

    },
    alertMinMax(val, minmax) {
      var thisVar = this;
      thisVar.minMaxAlert = 'Dit veld heeft een ' + minmax + ' van ' + val;
      clearTimeout(showErrorTimeout);
      showErrorTimeout = setTimeout(function() {
        thisVar.minMaxAlert = '';
      }, 5000);
    },
    calcDrawing(side, input, val) {
      var thisVar = this;

      const slider = thisVar.findType(thisVar.findElement.slider);
      const totalWidth = Number(slider.value) - Number(thisVar.drawingValue2);

      thisVar.maxWidthDouble = Number(slider.value) - Number(thisVar.drawingDoubleValue2) - Number(thisVar.drawingDoubleValue4) - Number(thisVar.minWidthDouble) - Number(thisVar.minWidthDouble);

      // force min and max
      if(side === 'left' && input > thisVar.maxWidthLeft) {
        thisVar.alertMinMax(thisVar.maxWidthLeft, 'max');
      } else if(side === 'left' && input < thisVar.minWidthLeft) {
        thisVar.alertMinMax(thisVar.minWidthLeft, 'min');
      } else if(side === 'right' && input > thisVar.maxWidthRight) {
        thisVar.alertMinMax(thisVar.maxWidthRight, 'max');
      } else if(side === 'right' && input < thisVar.minWidthRight) {
        thisVar.alertMinMax(thisVar.minWidthRight, 'min');
      } else if(side === 'double1' && input > thisVar.maxWidthDouble) {
        thisVar.alertMinMax(thisVar.maxWidthDouble, 'max');
      } else if(side === 'double1' && input < thisVar.minWidthDouble) {
        thisVar.alertMinMax(thisVar.minWidthDouble, 'min');
      } else if(side === 'double3' && input > thisVar.maxWidthDouble) {
        thisVar.alertMinMax(thisVar.maxWidthDouble, 'max');
      } else if(side === 'double3' && input < thisVar.minWidthDouble) {
        thisVar.alertMinMax(thisVar.minWidthDouble, 'min');
      } else if(side === 'double5' && input > thisVar.maxWidthDouble) {
        thisVar.alertMinMax(thisVar.maxWidthDouble, 'max');
      } else if(side === 'double5' && input < thisVar.minWidthDouble) {
        thisVar.alertMinMax(thisVar.minWidthDouble, 'min');
      }

      thisVar.maxWidthDouble = Number(slider.value) - Number(thisVar.drawingDoubleValue2) - Number(thisVar.drawingDoubleValue4) - Number(thisVar.minWidthDouble) - Number(thisVar.minWidthDouble);

      // force min and max
      if (side === 'left' && input > thisVar.maxWidthLeft) {
        thisVar.drawingValue1 = thisVar.maxWidthLeft;
      }
      if (side === 'left' && input < thisVar.minWidthLeft) {
        thisVar.drawingValue1 = thisVar.minWidthLeft;
      }
      if (side === 'right' && input > thisVar.maxWidthRight) {
        thisVar.drawingValue1 = thisVar.maxWidthRight;
      }
      if (side === 'right' && input < thisVar.minWidthRight) {
        thisVar.drawingValue1 = thisVar.minWidthRight;
      }

      // force min and max
      if (side === 'double1' && input > thisVar.maxWidthDouble) {
        thisVar.drawingDoubleValue1 = thisVar.maxWidthDouble;
      }
      if (side === 'double1' && input < thisVar.minWidthDouble) {
        thisVar.drawingDoubleValue1 = thisVar.minWidthDouble;
      }
      if (side === 'double3' && input > thisVar.maxWidthDouble) {
        thisVar.drawingDoubleValue3 = thisVar.maxWidthDouble;
      }
      if (side === 'double3' && input < thisVar.minWidthDouble) {
        thisVar.drawingDoubleValue3 = thisVar.minWidthDouble;
      }
      if (side === 'double5' && input > thisVar.maxWidthDouble) {
        thisVar.drawingDoubleValue5 = thisVar.maxWidthDouble;
      }
      if (side === 'double5' && input < thisVar.minWidthDouble) {
        thisVar.drawingDoubleValue5 = thisVar.minWidthDouble;
      }

      if (side === 'left') {
        thisVar.drawingValue3 = Number(slider.value) - Number(thisVar.drawingValue1) - Number(thisVar.drawingValue2);
      } else if (side === 'right') {
        thisVar.drawingValue1 = Number(slider.value) - Number(thisVar.drawingValue3) - Number(thisVar.drawingValue2);
      } else {
        thisVar.drawingValue1 = Math.ceil(totalWidth / 2);
        thisVar.drawingValue3 = totalWidth - thisVar.drawingValue1;
      }

      if (side === 'double1') {
        const drawingDoubleValue3temp = Number(slider.value) - Number(thisVar.drawingDoubleValue1) - Number(thisVar.drawingDoubleValue2) - Number(thisVar.drawingDoubleValue4) - Number(thisVar.drawingDoubleValue5);
        if (Number(drawingDoubleValue3temp) < thisVar.minWidthDouble) {
          thisVar.drawingDoubleValue3 = thisVar.minWidthDouble;
        } else {
          thisVar.drawingDoubleValue3 = drawingDoubleValue3temp;
        }
        thisVar.drawingDoubleValue5 = Number(slider.value) - Number(thisVar.drawingDoubleValue1) - Number(thisVar.drawingDoubleValue2) - Number(thisVar.drawingDoubleValue3) - Number(thisVar.drawingDoubleValue4);
      } else if (side === 'double3') {
        const drawingDoubleValue5temp = Number(slider.value) - Number(thisVar.drawingDoubleValue1) - Number(thisVar.drawingDoubleValue2) - Number(thisVar.drawingDoubleValue3) - Number(thisVar.drawingDoubleValue4);
        if (Number(drawingDoubleValue5temp) < thisVar.minWidthDouble) {
          thisVar.drawingDoubleValue5 = thisVar.minWidthDouble;
        } else {
          thisVar.drawingDoubleValue5 = drawingDoubleValue5temp;
        }
        thisVar.drawingDoubleValue1 = Number(slider.value) - Number(thisVar.drawingDoubleValue5) - Number(thisVar.drawingDoubleValue2) - Number(thisVar.drawingDoubleValue3) - Number(thisVar.drawingDoubleValue4);
      } else if (side === 'double5') {
        const drawingDoubleValue1temp = Number(slider.value) - Number(thisVar.drawingDoubleValue2) - Number(thisVar.drawingDoubleValue3) - Number(thisVar.drawingDoubleValue4) - Number(thisVar.drawingDoubleValue5);
        if (Number(drawingDoubleValue1temp) < thisVar.minWidthDouble) {
          thisVar.drawingDoubleValue1 = thisVar.minWidthDouble;
        } else {
          thisVar.drawingDoubleValue1 = drawingDoubleValue1temp;
        }
        thisVar.drawingDoubleValue3 = Number(slider.value) - Number(thisVar.drawingDoubleValue1) - Number(thisVar.drawingDoubleValue2) - Number(thisVar.drawingDoubleValue4) - Number(thisVar.drawingDoubleValue5);
      } else {
        thisVar.drawingDoubleValue1 = Math.ceil((Number(slider.value) - Number(thisVar.drawingDoubleValue2) - Number(thisVar.drawingDoubleValue4)) / 3);
        thisVar.drawingDoubleValue3 = Math.ceil((Number(slider.value) - Number(thisVar.drawingDoubleValue2) - Number(thisVar.drawingDoubleValue4) - Number(thisVar.drawingDoubleValue1)) / 2);
        thisVar.drawingDoubleValue5 = Number(slider.value) - Number(thisVar.drawingDoubleValue1) - Number(thisVar.drawingDoubleValue2) - Number(thisVar.drawingDoubleValue3) - Number(thisVar.drawingDoubleValue4);
      }

      // min max input fields
      thisVar.maxWidthLeft = totalWidth - thisVar.minWidthRight;
      thisVar.maxWidthRight = totalWidth - thisVar.minWidthLeft;

      // positions
      const offset = 0.8;
      const start = 0;
      const middle = 15;
      const leftTopOffset = start + offset;
      const fullWidth = 100;
      const fullWidthOffset = fullWidth + offset;
      const fullHeight = 25;
      const fullHeightOffset = fullHeight + offset;

      const leftBottom = leftTopOffset + ',' + fullHeightOffset; // "0.8,26,8"
      const rightBottom = fullWidthOffset + ',' + fullHeightOffset; // "100.8,26,8"
      const leftTop = leftTopOffset + ',' + leftTopOffset; // "0.8,0.8"
      const rightTop = fullWidthOffset + ',' + leftTopOffset; // "100.80,0.8"

      const leftvalue = (thisVar.drawingValue1 / (slider.value / fullWidth));
      const leftInputTop = leftvalue + ',' + leftTopOffset;
      const leftInputMiddle = leftvalue + ',' + middle;

      const rightvalue = (leftvalue + (thisVar.drawingValue2 / (slider.value / fullWidth)));
      const rightInputTop = rightvalue + ',' + leftTopOffset;
      const rightInputMiddle = rightvalue + ',' + middle;

      const value80 = offset + (thisVar.drawingDoubleValue1 / (slider.value / fullWidth)) + (thisVar.drawingDoubleValue2 / (slider.value / fullWidth)) + (thisVar.drawingDoubleValue3 / (slider.value / fullWidth) + (thisVar.drawingDoubleValue4 / (slider.value / fullWidth)));
      const value60 = offset + (thisVar.drawingDoubleValue1 / (slider.value / fullWidth)) + (thisVar.drawingDoubleValue2 / (slider.value / fullWidth)) + (thisVar.drawingDoubleValue3 / (slider.value / fullWidth));
      const value40 = offset + (thisVar.drawingDoubleValue1 / (slider.value / fullWidth)) + (thisVar.drawingDoubleValue2 / (slider.value / fullWidth));
      const value20 = offset + (thisVar.drawingDoubleValue1 / (slider.value / fullWidth));

      const topDouble80 = value80 + ',' + leftTopOffset; // "80,0.8"
      const bottomDouble80 = value80 + ',' + middle; //"80,16.627"
      const bottomDouble60 = value60 + ',' + middle; //"60,16.627"
      const topDouble60 = value60 + ',' + leftTopOffset; //"60,0.8"
      const topDouble40 = value40 + ',' + leftTopOffset; //"40,0.8"
      const bottomDouble40 = value40 + ',' + middle; //"40,16.627"
      const bottomDouble20 = value20 + ',' + middle; //"20,16.627"
      const topDouble20 = value20 + ',' + leftTopOffset; //"20,0.8"

      // Gray drawer position
      thisVar.polygonPoints = leftTop + " " +
          leftBottom + " " +
          rightBottom + " " +
          rightTop + " " +
          rightInputTop + " " +
          rightInputMiddle + " " +
          leftInputMiddle + " " +
          leftInputTop;

      // Gray drawerDouble position
      thisVar.polygonPointsDouble = leftTop + " " +
          leftBottom + " " +
          rightBottom + " " +
          rightTop + " " +
          topDouble80 + " " +
          bottomDouble80 + " " +
          bottomDouble60 + " " +
          topDouble60 + " " +
          topDouble40 + " " +
          bottomDouble40 + " " +
          bottomDouble20 + " " +
          topDouble20;

      // orange dotted line position
      thisVar.lineVal1 = leftvalue + ",0 " + leftvalue + ",2.504 0.8,2.504 0.8,0";
      thisVar.lineVal2x2 = leftvalue;
      thisVar.lineVal2x1 = rightvalue;
      thisVar.lineVal3 = "100.801,0 100.801,2.504 " + rightvalue + ",2.504 " + rightvalue + ",0";

      thisVar.lineValDouble1 = value20 + ",0 " + value20 + ",2.504 0.8,2.504 0.8,0";
      thisVar.lineValDouble2x1 = value40;
      thisVar.lineValDouble2x2 = value20;
      thisVar.lineValDouble3 = value60 + ",0 " + value60 + ",2.504 " + value40 + ",2.504 " + value40 + ",0";
      thisVar.lineValDouble4x1 = value60;
      thisVar.lineValDouble4x2 = value80;
      thisVar.lineValDouble5 = "100,0 100,2.504 " + value80 + ",2.504 " + value80 + ",0";

      thisVar.fixedValue1 = (leftvalue / 2);
      thisVar.fixedValue2 = ((rightvalue - leftvalue) / 2) + leftvalue;
      thisVar.fixedValue3 = ((fullWidth - rightvalue) / 2) + rightvalue;

      thisVar.fixedValueDouble1 = value20 / 2;
      thisVar.fixedValueDouble2 = ((value40 - value20) / 2) + value20;
      thisVar.fixedValueDouble3 = ((value60 - value40) / 2) + value40;
      thisVar.fixedValueDouble4 = ((value80 - value60) / 2) + value60;
      thisVar.fixedValueDouble5 = ((fullWidth - value80) / 2) + value80;

      thisVar.widthVal1 = leftvalue;
      thisVar.widthVal2 = rightvalue - leftvalue - 1.6;
      thisVar.widthVal3 = fullWidth - rightvalue;

      thisVar.widthValDouble1 = value20;
      thisVar.widthValDouble2 = value40 - value20;
      thisVar.widthValDouble3 = value60 - value40 - 1.4;
      thisVar.widthValDouble4 = value80 - value60;
      thisVar.widthValDouble5 = fullWidth - value80 - 1;

      thisVar.fullWidthDrawing = slider.value;

      thisVar.setValueOfDrawing();

    },
    getOptionsCustomProducts(item, array = null, hash = null) {
      axios
          /* build Array from all subcategories under all the categories under 'Lade op maat'
                  So..
                  Lade op maat
                      Blum tandembox
                          Blumotion (softclose) <----
                          Tip-on + Blumotion  <----
                      Blum Legrabox
                          Blumotion (Softclose) <-----
                          Tip-On + Blumotion <----
               */
          // .get('./static/getCatInfoDetail' + index + '.json') //https://duovorm.test/api/categories?filter[parentId]=83 bijv. 83 is sub id from lade op maat cat

          //25487 should be replaced by item later on
          //.get('/custom/plugins/KienerDuo/app/dist/static/nieuwe-opzet.json', {
          .get(this.SWURL + '/DuoLadeConfigurator/options/?product=' + item.productId, {
            auth: {
              username: this.APIUSR,
              password: this.APIPASWD
            }
          })
          .then(response => {
            let step1 = [];

            if(array) {
              step1 = [array[0]];
            }
            else {
              if(this.stepperSteps[0]) {
                step1 = [this.stepperSteps[0]];
              }
              else {
                step1 = [this.steps[0]];
              }
            }
            // console.log('response');
            // console.info(step1);
            const CustomProducts = response.data;

            const newSteps = step1.concat(CustomProducts);

            localStorage.steps = JSON.stringify(newSteps);
            this.stepperSteps = newSteps;
            this.openAllRecap();

            // set selected product id for building hash
            this.selectedProductId = item.productId;
            this.selectedProductNumber = item.productNumber;
            if(hash !== null) {
              this.getHashConfiguration(hash);
            }
            // done loading
            this.LoadingCustomProducts = false;
            this.heightLoader = false;

          })
          .catch(error => {
            console.log(error);
            this.heightLoader = false;
          })
    },
    setStepsFromConfiguration(configuration) {
      let arrayFromHash = [];

      for (const [key, value] of Object.entries(configuration)) {
        var id = key.replace(/\D/g, "");
        arrayFromHash[id.toString()] = value;
        // console.log(`${id}: ${value}`);
      }

      //set values based on array
      this.stepperSteps.forEach(function (item) {
        if(item.number < 2) {
          return;
        }
        item.accordion.forEach(function (acc) {
          acc.items.forEach(function (option) {
            let optionId = Number(option.id);
            if(!option.options) {
              if(option.type === 'slider'){
                option.value = arrayFromHash[optionId];
                option.selectedLabel = arrayFromHash[optionId] + 'mm';
              }
              else {
                option.value = arrayFromHash[optionId];
              }
              return;
            }

            if(arrayFromHash[optionId] && option.options) {
              let getOptionValues = [];
              getOptionValues = option.options.filter(optionValue => optionValue.value === arrayFromHash[option.id]);

              if(!getOptionValues[0]) {
                getOptionValues = option.options.filter(optionValue => optionValue.label === arrayFromHash[option.id]);
              }
              if(getOptionValues[0]) {
                option.value = getOptionValues[0].value;
                option.valCode = getOptionValues[0].valCode;
                option.selectedLabel = getOptionValues[0].label;
                option.selectedPrice = getOptionValues[0].price;
                // console.log(option.valCode + ' - ' + getOptionValues[0].label);
              }
              else {
                console.log('error:' + getOptionValues);
              }
            }
          });
        });
      });
      //console.info(this.stepperSteps);
      // this.changeImageURL();
      // this.stepperSteps = selectedSteps;
      // done loading
      this.LoadingCustomProducts = false;
    },
    getHashConfiguration(hash) {
      axios
          /* build Array from all subcategories under all the categories under 'Lade op maat'
                  So..
                  Lade op maat
                      Blum tandembox
                          Blumotion (softclose) <----
                          Tip-on + Blumotion  <----
                      Blum Legrabox
                          Blumotion (Softclose) <-----
                          Tip-On + Blumotion <----
               */
          // .get('./static/getCatInfoDetail' + index + '.json') //https://duovorm.test/api/categories?filter[parentId]=83 bijv. 83 is sub id from lade op maat cat

          //25487 should be replaced by item later on
          //.get('/custom/plugins/KienerDuo/app/dist/static/nieuwe-opzet.json', {
          .get(this.SWURL + '/widgets/SwagCustomProducts/getConfiguration?hash=' + hash, {
            auth: {
              username: this.APIUSR,
              password: this.APIPASWD
            }
          })
          .then(response => {
            if(response.data.success) {
              /*
                selectedProductId: "",
                selectedProductNumber: "",
                currentHash: "",
               */
              this.selectedProductNumber = response.data.configuration['custom-option-id--number'];

              const CustomProductsConfiguration = response.data.configuration;
              this.setStepsFromConfiguration(CustomProductsConfiguration);
            } else {
              console.error('No hash configuration');
            }

          })
          .catch(error => {
            console.log(error)
          })
    },
  },
  mounted () {
    mountedMethod.runMounted(this); // give pleasework a reference to the Vue instance
  }
}
</script>

<style>
.item-grayedout .v-radio:not(:first-of-type) {
  cursor: no-drop;
  filter: grayscale(100%);
  opacity: 0.4;
  pointer-events: none;
}
.item-grayedout .v-radio:not(:first-of-type) .v-badge__badge {
  pointer-events: none;
}

.item-grayedout-forceyes .v-radio:first-of-type {
  cursor: no-drop;
  filter: grayscale(100%);
  opacity: 0.4;
  pointer-events: none;
}
.item-grayedout-forceyes .v-radio:first-of-type .v-badge__badge {
  pointer-events: none;
}
.accordion-grayedout button.v-expansion-panel-header:not(.v-expansion-panel-header--active) {
  cursor: no-drop;
  filter: grayscale(100%);
  opacity: 0.4;
  pointer-events: none;
}

.radio-label,
.label-inner,
.label-inner-img-label{
  height: 100%;
}
.label-inner-img-label {
  display: flex;
  flex-direction: column;
}
.v-menu__content {
  transform: translateY(-4px);
}
.label-inner-img {
  flex-grow: 1;
  display: flex;
  align-items: center;
}
.label-inner-img img {
  margin: 1rem 0;
}
.recap--table.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row),
.recap--table.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row) {
  border-bottom: 0;
}
.item--title {
  margin-top: 1rem;
  margin-bottom: .4rem;
  font-size: 1rem;
}
.polygon-drawing {
  position: relative;
}
.full-width-drawing {
  position: relative;
  z-index: 1;
  text-align: center;
  font-weight: bold;
}
.drawing-container .v-text-field__details {
  display: none;
}
.line-drawing {
  position: relative;
  z-index: 1;
}
.polygon-drawing:after {
  position: absolute;
  top: 35%;
  left: -10px;
  right: -10px;
  bottom: -10px;
  content: "";
  display: inline-block;
  background: linear-gradient(0deg, rgba(255,255,255,1) 30%, rgba(255,255,255,0) 90%);
}
.recap--table .v-data-table__wrapper {
  margin-left: -1rem;
  margin-right: -1rem;
}
.centered-number input[type="number"] {
  text-align: center;
}
.stepContainer5 .v-expansion-panel-header__icon {
  display: none;
}
.radio-label .badgeAndTooltip .icon-tooltip {
  top: -26px;
}
</style>
